export const reg_json = [
  {
    "id": "NAM",
    "name": "North America",
    "db": [
      {
        "id": "CA",
        "un": "CA",
        "name": "Canada",
        "db": [
          {
            "id": "CA-AB",
            "name": "Alberta"
          },
          {
            "id": "CA-BC",
            "name": "British Columbia"
          },
          {
            "id": "CA-MB",
            "name": "Manitoba"
          },
          {
            "id": "CA-NB",
            "name": "New Brunswick"
          },
          {
            "id": "CA-NL",
            "name": "Newfoundland and Labrador"
          },
          {
            "id": "CA-NT",
            "name": "Northwest Territories"
          },
          {
            "id": "CA-NS",
            "name": "Nova Scotia"
          },
          {
            "id": "CA-NU",
            "name": "Nunavut"
          },
          {
            "id": "CA-ON",
            "name": "Ontario"
          },
          {
            "id": "CA-PE",
            "name": "Prince Edward Island"
          },
          {
            "id": "CA-QC",
            "name": "Quebec"
          },
          {
            "id": "CA-SK",
            "name": "Saskatchewan"
          },
          {
            "id": "CA-YT",
            "name": "Yukon"
          }
        ],
        "total": 13
      },
      {
        "id": "GL",
        "un": "DK",
        "name": "Greenland",
        "db": [
          {
            "id": "GL:E",
            "name": "East"
          },
          {
            "id": "GL:NW",
            "name": "Northwest"
          },
          {
            "id": "GL:SW",
            "name": "Southwest"
          }
        ],
        "total": 3
      },
      {
        "id": "PM",
        "un": "FR",
        "name": "Saint Pierre and Miquelon",
        "db": [
          {
            "id": "PM-M",
            "name": "Miquelon"
          },
          {
            "id": "PM-P",
            "name": "Saint-Pierre"
          }
        ],
        "total": 2
      },
      {
        "id": "US",
        "un": "US",
        "name": "United States of America",
        "db": [
          {
            "id": "US-AL",
            "name": "Alabama"
          },
          {
            "id": "US-AK",
            "name": "Alaska"
          },
          {
            "id": "US-AZ",
            "name": "Arizona"
          },
          {
            "id": "US-AR",
            "name": "Arkansas"
          },
          {
            "id": "US-CA",
            "name": "California"
          },
          {
            "id": "US-CO",
            "name": "Colorado"
          },
          {
            "id": "US-CT",
            "name": "Connecticut"
          },
          {
            "id": "US-DE",
            "name": "Delaware"
          },
          {
            "id": "US-DC",
            "name": "District of Columbia"
          },
          {
            "id": "US-FL",
            "name": "Florida"
          },
          {
            "id": "US-GA",
            "name": "Georgia"
          },
          {
            "id": "US-ID",
            "name": "Idaho"
          },
          {
            "id": "US-IL",
            "name": "Illinois"
          },
          {
            "id": "US-IN",
            "name": "Indiana"
          },
          {
            "id": "US-IA",
            "name": "Iowa"
          },
          {
            "id": "US-KS",
            "name": "Kansas"
          },
          {
            "id": "US-KY",
            "name": "Kentucky"
          },
          {
            "id": "US-LA",
            "name": "Louisiana"
          },
          {
            "id": "US-ME",
            "name": "Maine"
          },
          {
            "id": "US-MD",
            "name": "Maryland"
          },
          {
            "id": "US-MA",
            "name": "Massachusetts"
          },
          {
            "id": "US-MI",
            "name": "Michigan"
          },
          {
            "id": "US-MN",
            "name": "Minnesota"
          },
          {
            "id": "US-MS",
            "name": "Mississippi"
          },
          {
            "id": "US-MO",
            "name": "Missouri"
          },
          {
            "id": "US-MT",
            "name": "Montana"
          },
          {
            "id": "US-NE",
            "name": "Nebraska"
          },
          {
            "id": "US-NV",
            "name": "Nevada"
          },
          {
            "id": "US-NH",
            "name": "New Hampshire"
          },
          {
            "id": "US-NJ",
            "name": "New Jersey"
          },
          {
            "id": "US-NM",
            "name": "New Mexico"
          },
          {
            "id": "US-NY",
            "name": "New York"
          },
          {
            "id": "US-NC",
            "name": "North Carolina"
          },
          {
            "id": "US-ND",
            "name": "North Dakota"
          },
          {
            "id": "US-OH",
            "name": "Ohio"
          },
          {
            "id": "US-OK",
            "name": "Oklahoma"
          },
          {
            "id": "US-OR",
            "name": "Oregon"
          },
          {
            "id": "US-PA",
            "name": "Pennsylvania"
          },
          {
            "id": "US-RI",
            "name": "Rhode Island"
          },
          {
            "id": "US-SC",
            "name": "South Carolina"
          },
          {
            "id": "US-SD",
            "name": "South Dakota"
          },
          {
            "id": "US-TN",
            "name": "Tennessee"
          },
          {
            "id": "US-TX",
            "name": "Texas"
          },
          {
            "id": "US-UT",
            "name": "Utah"
          },
          {
            "id": "US-VT",
            "name": "Vermont"
          },
          {
            "id": "US-VA",
            "name": "Virginia"
          },
          {
            "id": "US-WA",
            "name": "Washington"
          },
          {
            "id": "US-WV",
            "name": "West Virginia"
          },
          {
            "id": "US-WI",
            "name": "Wisconsin"
          },
          {
            "id": "US-WY",
            "name": "Wyoming"
          }
        ],
        "total": 50
      }
    ],
    "total": 68,
    "timestamp": "1758826953"
  },
  {
    "id": "CAM",
    "name": "Central America",
    "db": [
      {
        "id": "BZ",
        "un": "BZ",
        "name": "Belize",
        "db": [
          {
            "id": "BZ-C",
            "name": "Coastal"
          },
          {
            "id": "BZ-I",
            "name": "Inland"
          }
        ],
        "total": 2
      },
      {
        "id": "CR",
        "un": "CR",
        "name": "Costa Rica"
      },
      {
        "id": "SV",
        "un": "SV",
        "name": "El Salvador"
      },
      {
        "id": "GT",
        "un": "GT",
        "name": "Guatemala",
        "db": [
          {
            "id": "GT-18",
            "name": "Caribbean"
          },
          {
            "id": "GT-H",
            "name": "Highlands"
          },
          {
            "id": "GT-P",
            "name": "Pacific"
          },
          {
            "id": "GT-17",
            "name": "Petén"
          }
        ],
        "total": 4
      },
      {
        "id": "HN",
        "un": "HN",
        "name": "Honduras",
        "db": [
          {
            "id": "HN-IB",
            "name": "Bay Islands"
          },
          {
            "id": "HN-C",
            "name": "Caribbean"
          },
          {
            "id": "HN-H",
            "name": "Highlands"
          },
          {
            "id": "HN-P",
            "name": "Pacific"
          }
        ],
        "total": 4
      },
      {
        "id": "MX",
        "un": "MX",
        "name": "Mexico",
        "db": [
          {
            "id": "MX-AGU",
            "name": "Aguascalientes"
          },
          {
            "id": "MX-BCN",
            "name": "Baja California"
          },
          {
            "id": "MX-BCS",
            "name": "Baja California Sur"
          },
          {
            "id": "MX-CAM",
            "name": "Campeche"
          },
          {
            "id": "MX-CHP",
            "name": "Chiapas"
          },
          {
            "id": "MX-CHH",
            "name": "Chihuahua"
          },
          {
            "id": "MX-COA",
            "name": "Coahuila"
          },
          {
            "id": "MX-COL",
            "name": "Colima"
          },
          {
            "id": "MX-DUR",
            "name": "Durango"
          },
          {
            "id": "MX-GUA",
            "name": "Guanajuato"
          },
          {
            "id": "MX-GRO",
            "name": "Guerrero"
          },
          {
            "id": "MX-HID",
            "name": "Hidalgo"
          },
          {
            "id": "MX-JAL",
            "name": "Jalisco"
          },
          {
            "id": "MX-CMX",
            "name": "Mexico City"
          },
          {
            "id": "MX-MIC",
            "name": "Michoacán"
          },
          {
            "id": "MX-MOR",
            "name": "Morelos"
          },
          {
            "id": "MX-NAY",
            "name": "Nayarit"
          },
          {
            "id": "MX-NLE",
            "name": "Nuevo León"
          },
          {
            "id": "MX-OAX",
            "name": "Oaxaca"
          },
          {
            "id": "MX-PUE",
            "name": "Puebla"
          },
          {
            "id": "MX-QUE",
            "name": "Querétaro"
          },
          {
            "id": "MX-ROO",
            "name": "Quintana Roo"
          },
          {
            "id": "MX-SLP",
            "name": "San Luis Potosi"
          },
          {
            "id": "MX-SIN",
            "name": "Sinaloa"
          },
          {
            "id": "MX-SON",
            "name": "Sonora"
          },
          {
            "id": "MX-MEX",
            "name": "State of Mexico"
          },
          {
            "id": "MX-TAB",
            "name": "Tabasco"
          },
          {
            "id": "MX-TAM",
            "name": "Tamaulipas"
          },
          {
            "id": "MX-TLA",
            "name": "Tlaxcala"
          },
          {
            "id": "MX-VER",
            "name": "Veracruz"
          },
          {
            "id": "MX-YUC",
            "name": "Yucatán"
          },
          {
            "id": "MX-ZAC",
            "name": "Zacatecas"
          }
        ],
        "total": 32
      },
      {
        "id": "NI",
        "un": "NI",
        "name": "Nicaragua"
      },
      {
        "id": "PA",
        "un": "PA",
        "name": "Panama"
      }
    ],
    "total": 46
  },
  {
    "id": "CRB",
    "name": "Caribbean",
    "db": [
      {
        "id": "AI",
        "un": "GB",
        "name": "Anguilla"
      },
      {
        "id": "AG",
        "un": "AG",
        "name": "Antigua and Barbuda",
        "db": [
          {
            "id": "AG:A",
            "name": "Antigua"
          },
          {
            "id": "AG-10",
            "name": "Barbuda"
          }
        ],
        "total": 2
      },
      {
        "id": "AW",
        "un": "NL",
        "name": "Aruba"
      },
      {
        "id": "BS",
        "un": "BS",
        "name": "Bahamas",
        "db": [
          {
            "id": "BS:N",
            "name": "North"
          },
          {
            "id": "BS:S",
            "name": "South"
          }
        ],
        "total": 2
      },
      {
        "id": "BB",
        "un": "BB",
        "name": "Barbados"
      },
      {
        "id": "BQ",
        "un": "NL",
        "name": "Bonaire, Sint Eustatius and Saba",
        "db": [
          {
            "id": "BQ-BO",
            "name": "Bonaire"
          },
          {
            "id": "BQ-SA",
            "name": "Saba"
          },
          {
            "id": "BQ-SE",
            "name": "Sint Eustatius"
          }
        ],
        "total": 3
      },
      {
        "id": "KY",
        "un": "GB",
        "name": "Cayman Islands",
        "db": [
          {
            "id": "KY:GC",
            "name": "Grand Cayman"
          },
          {
            "id": "KY:SI",
            "name": "Sister Islands"
          }
        ],
        "total": 2
      },
      {
        "id": "CO",
        "un": "CO",
        "name": "Colombia",
        "db": [
          {
            "id": "CO-SAP",
            "name": "San Andrés, Providencia y Santa Catalina"
          }
        ],
        "total": 1
      },
      {
        "id": "CU",
        "un": "CU",
        "name": "Cuba",
        "db": [
          {
            "id": "CU:C",
            "name": "Central"
          },
          {
            "id": "CU:E",
            "name": "East"
          },
          {
            "id": "CU-99",
            "name": "Isla de la Juventud"
          },
          {
            "id": "CU:W",
            "name": "West"
          }
        ],
        "total": 4
      },
      {
        "id": "CW",
        "un": "NL",
        "name": "Curaçao"
      },
      {
        "id": "DM",
        "un": "DM",
        "name": "Dominica"
      },
      {
        "id": "DO",
        "un": "DO",
        "name": "Dominican Republic"
      },
      {
        "id": "GD",
        "un": "GD",
        "name": "Grenada"
      },
      {
        "id": "GP",
        "un": "FR",
        "name": "Guadeloupe"
      },
      {
        "id": "HT",
        "un": "HT",
        "name": "Haiti"
      },
      {
        "id": "JM",
        "un": "JM",
        "name": "Jamaica"
      },
      {
        "id": "MQ",
        "un": "FR",
        "name": "Martinique"
      },
      {
        "id": "MS",
        "un": "GB",
        "name": "Montserrat"
      },
      {
        "id": "PR",
        "un": "US",
        "name": "Puerto Rico",
        "db": [
          {
            "id": "PR",
            "name": "Puerto Rico"
          }
        ],
        "total": 1
      },
      {
        "id": "BL",
        "un": "FR",
        "name": "Saint Barthélemy"
      },
      {
        "id": "KN",
        "un": "KN",
        "name": "Saint Kitts and Nevis",
        "db": [
          {
            "id": "KN-N",
            "name": "Nevis"
          },
          {
            "id": "KN-K",
            "name": "Saint Kitts"
          }
        ],
        "total": 2
      },
      {
        "id": "LC",
        "un": "LC",
        "name": "Saint Lucia"
      },
      {
        "id": "MF",
        "un": "FR",
        "name": "Saint Martin"
      },
      {
        "id": "VC",
        "un": "VC",
        "name": "Saint Vincent and the Grenadines",
        "db": [
          {
            "id": "VC-06",
            "name": "Grenadines"
          },
          {
            "id": "VC:0",
            "name": "Saint Vincent"
          }
        ],
        "total": 2
      },
      {
        "id": "SX",
        "un": "NL",
        "name": "Sint Maarten"
      },
      {
        "id": "TT",
        "un": "TT",
        "name": "Trinidad and Tobago",
        "db": [
          {
            "id": "TT-TOB",
            "name": "Tobago"
          },
          {
            "id": "TT",
            "name": "Trinidad"
          }
        ],
        "total": 2
      },
      {
        "id": "TC",
        "un": "GB",
        "name": "Turks and Caicos Islands",
        "db": [
          {
            "id": "TC:C",
            "name": "Caicos Islands"
          },
          {
            "id": "TC:T",
            "name": "Turks Islands"
          }
        ],
        "total": 2
      },
      {
        "id": "VG",
        "un": "GB",
        "name": "Virgin Islands (British)"
      },
      {
        "id": "VI",
        "un": "US",
        "name": "Virgin Islands (U.S.)",
        "db": [
          {
            "id": "VI",
            "name": "United States Virgin Islands"
          }
        ],
        "total": 1
      }
    ],
    "total": 41
  },
  {
    "id": "SAM",
    "name": "South America",
    "db": [
      {
        "id": "AR",
        "un": "AR",
        "name": "Argentina",
        "db": [
          {
            "id": "AR-C",
            "name": "Autonomous City of Buenos Aires"
          },
          {
            "id": "AR-B",
            "name": "Buenos Aires"
          },
          {
            "id": "AR-K",
            "name": "Catamarca"
          },
          {
            "id": "AR-H",
            "name": "Chaco"
          },
          {
            "id": "AR-U",
            "name": "Chubut Province"
          },
          {
            "id": "AR-X",
            "name": "Córdoba"
          },
          {
            "id": "AR-W",
            "name": "Corrientes"
          },
          {
            "id": "AR-E",
            "name": "Entre Ríos Province"
          },
          {
            "id": "AR-P",
            "name": "Formosa"
          },
          {
            "id": "AR-Y",
            "name": "Jujuy"
          },
          {
            "id": "AR-L",
            "name": "La Pampa"
          },
          {
            "id": "AR-F",
            "name": "La Rioja"
          },
          {
            "id": "AR-M",
            "name": "Mendoza"
          },
          {
            "id": "AR-N",
            "name": "Misiones"
          },
          {
            "id": "AR-Q",
            "name": "Neuquén Province"
          },
          {
            "id": "AR-R",
            "name": "Río Negro Province"
          },
          {
            "id": "AR-A",
            "name": "Salta"
          },
          {
            "id": "AR-J",
            "name": "San Juan"
          },
          {
            "id": "AR-D",
            "name": "San Luis"
          },
          {
            "id": "AR-Z",
            "name": "Santa Cruz Province"
          },
          {
            "id": "AR-S",
            "name": "Santa Fe"
          },
          {
            "id": "AR-G",
            "name": "Santiago del Estero"
          },
          {
            "id": "AR-V",
            "name": "Tierra del Fuego Province"
          },
          {
            "id": "AR-T",
            "name": "Tucumán"
          }
        ],
        "total": 24
      },
      {
        "id": "BO",
        "un": "BO",
        "name": "Bolivia",
        "db": [
          {
            "id": "BO-1",
            "name": "Altiplano"
          },
          {
            "id": "BO-2",
            "name": "Sub-Andean Bolivia"
          },
          {
            "id": "BO-3",
            "name": "Tropical Lowlands"
          }
        ],
        "total": 3
      },
      {
        "id": "BR",
        "un": "BR",
        "name": "Brazil",
        "db": [
          {
            "id": "BR-AC",
            "name": "Acre"
          },
          {
            "id": "BR-AL",
            "name": "Alagoas"
          },
          {
            "id": "BR-AP",
            "name": "Amapá"
          },
          {
            "id": "BR-AM",
            "name": "Amazonas"
          },
          {
            "id": "BR-BA",
            "name": "Bahia"
          },
          {
            "id": "BR-CE",
            "name": "Ceará"
          },
          {
            "id": "BR-ES",
            "name": "Espírito Santo"
          },
          {
            "id": "BR-DF",
            "name": "Federal District"
          },
          {
            "id": "BR-GO",
            "name": "Goiás"
          },
          {
            "id": "BR-MA",
            "name": "Maranhão"
          },
          {
            "id": "BR-MT",
            "name": "Mato Grosso"
          },
          {
            "id": "BR-MS",
            "name": "Mato Grosso do Sul"
          },
          {
            "id": "BR-MG",
            "name": "Minas Gerais"
          },
          {
            "id": "BR-PA",
            "name": "Pará"
          },
          {
            "id": "BR-PB",
            "name": "Paraíba"
          },
          {
            "id": "BR-PR",
            "name": "Paraná"
          },
          {
            "id": "BR-PE",
            "name": "Pernambuco"
          },
          {
            "id": "BR-PI",
            "name": "Piauí"
          },
          {
            "id": "BR-RJ",
            "name": "Rio de Janeiro"
          },
          {
            "id": "BR-RN",
            "name": "Rio Grande do Norte"
          },
          {
            "id": "BR-RS",
            "name": "Rio Grande do Sul"
          },
          {
            "id": "BR-RO",
            "name": "Rondônia"
          },
          {
            "id": "BR-RR",
            "name": "Roraima"
          },
          {
            "id": "BR-SC",
            "name": "Santa Catarina"
          },
          {
            "id": "BR-SP",
            "name": "São Paulo"
          },
          {
            "id": "BR-SE",
            "name": "Sergipe"
          },
          {
            "id": "BR-TO",
            "name": "Tocantins"
          }
        ],
        "total": 27
      },
      {
        "id": "CL",
        "un": "CL",
        "name": "Chile",
        "db": [
          {
            "id": "CL-VS:2",
            "name": "Archipielago Juan Fernandez"
          },
          {
            "id": "CL:C",
            "name": "Central"
          },
          {
            "id": "CL:N",
            "name": "North"
          },
          {
            "id": "CL:P",
            "name": "Patagonia"
          },
          {
            "id": "CL:S",
            "name": "South"
          }
        ],
        "total": 5
      },
      {
        "id": "CO",
        "un": "CO",
        "name": "Colombia",
        "db": [
          {
            "id": "CO-AM",
            "name": "Amazonia"
          },
          {
            "id": "CO-AN",
            "name": "Andino"
          },
          {
            "id": "CO-C",
            "name": "Costa Norte"
          },
          {
            "id": "CO-O",
            "name": "Orinoquía"
          },
          {
            "id": "CO-P",
            "name": "Pacifica"
          }
        ],
        "total": 5
      },
      {
        "id": "EC",
        "un": "EC",
        "name": "Ecuador",
        "db": [
          {
            "id": "EC3",
            "name": "Amazon"
          },
          {
            "id": "EC1",
            "name": "Coast"
          },
          {
            "id": "EC-W",
            "name": "Galápagos"
          },
          {
            "id": "EC2",
            "name": "Sierra"
          }
        ],
        "total": 4
      },
      {
        "id": "GF",
        "un": "FR",
        "name": "French Guiana",
        "db": [
          {
            "id": "GF:C",
            "name": "Cayenne"
          },
          {
            "id": "GF:SG",
            "name": "Saint-Georges"
          },
          {
            "id": "GF:SL",
            "name": "Saint-Laurent-du-Maroni"
          }
        ],
        "total": 3
      },
      {
        "id": "GY",
        "un": "GY",
        "name": "Guyana",
        "db": [
          {
            "id": "GY:B",
            "name": "Berbice-Corentyne"
          },
          {
            "id": "GY:C",
            "name": "Coastal Plain"
          },
          {
            "id": "GY:H",
            "name": "Highlands"
          }
        ],
        "total": 3
      },
      {
        "id": "PY",
        "un": "PY",
        "name": "Paraguay",
        "db": [
          {
            "id": "PY-GC",
            "name": "Gran Chaco"
          },
          {
            "id": "PY-NP",
            "name": "Northern Paraneña"
          },
          {
            "id": "PY-PP",
            "name": "Paraná Plateau"
          },
          {
            "id": "PY-SP",
            "name": "Southern Paraneña"
          }
        ],
        "total": 4
      },
      {
        "id": "PE",
        "un": "PE",
        "name": "Peru",
        "db": [
          {
            "id": "PE-PUN",
            "name": "Altiplano"
          },
          {
            "id": "PE-CC",
            "name": "Central Coast"
          },
          {
            "id": "PE-CS",
            "name": "Central Sierra"
          },
          {
            "id": "PE-MDD",
            "name": "Madre de Dios"
          },
          {
            "id": "PE-NC",
            "name": "Northern Coast"
          },
          {
            "id": "PE-NS",
            "name": "Northern Sierra"
          },
          {
            "id": "PE-PA",
            "name": "Peruvian Amazon"
          },
          {
            "id": "PE-SC",
            "name": "Southern Coast"
          },
          {
            "id": "PE-SS",
            "name": "Southern Sierra"
          }
        ],
        "total": 9
      },
      {
        "id": "SR",
        "un": "SR",
        "name": "Suriname",
        "db": [
          {
            "id": "SR:E",
            "name": "East Coast"
          },
          {
            "id": "SR:R",
            "name": "Rainforest"
          },
          {
            "id": "SR:W",
            "name": "West Coast"
          }
        ],
        "total": 3
      },
      {
        "id": "UY",
        "un": "UY",
        "name": "Uruguay"
      },
      {
        "id": "VE",
        "un": "VE",
        "name": "Venezuela",
        "db": [
          {
            "id": "VE-AN",
            "name": "Andes"
          },
          {
            "id": "VE-CI",
            "name": "Caribbean Islands"
          },
          {
            "id": "VE-CR",
            "name": "Central Region"
          },
          {
            "id": "VE-CO",
            "name": "Coro region"
          },
          {
            "id": "VE-GU",
            "name": "Guayana"
          },
          {
            "id": "VE-LL",
            "name": "Los Llanos"
          },
          {
            "id": "VE-DO",
            "name": "Orinoco Delta"
          },
          {
            "id": "VE-V",
            "name": "Zulia"
          }
        ],
        "total": 8
      }
    ],
    "total": 99
  },
  {
    "id": "ATL",
    "name": "Atlantic Ocean",
    "db": [
      {
        "id": "BM",
        "un": "GB",
        "name": "Bermuda"
      },
      {
        "id": "BV",
        "un": "NO",
        "name": "Bouvet Island"
      },
      {
        "id": "BR",
        "un": "BR",
        "name": "Brazil",
        "db": [
          {
            "id": "BR-PE:1",
            "name": "Fernando de Noronha"
          }
        ],
        "total": 1
      },
      {
        "id": "FK",
        "un": "GB",
        "name": "Falkland Islands (Malvinas)"
      },
      {
        "id": "PT",
        "un": "PT",
        "name": "Portugal",
        "db": [
          {
            "id": "PT-20",
            "name": "Azores"
          },
          {
            "id": "PT-30",
            "name": "Madeira"
          }
        ],
        "total": 2
      },
      {
        "id": "SH",
        "un": "GB",
        "name": "Saint Helena, Ascension and Tristan da Cunha",
        "db": [
          {
            "id": "SH-AC",
            "name": "Ascension"
          },
          {
            "id": "SH-HL",
            "name": "Saint Helena"
          },
          {
            "id": "SH-TA",
            "name": "Tristan da Cunha"
          }
        ],
        "total": 3
      },
      {
        "id": "GS",
        "un": "GB",
        "name": "South Georgia and the South Sandwich Islands"
      },
      {
        "id": "ES",
        "un": "ES",
        "name": "Spain",
        "db": [
          {
            "id": "ES-CN",
            "name": "Canary Islands"
          }
        ],
        "total": 1
      }
    ],
    "total": 11
  },
  {
    "id": "EUW",
    "name": "Western Europe",
    "db": [
      {
        "id": "AT",
        "un": "AT",
        "name": "Austria",
        "db": [
          {
            "id": "AT-1",
            "name": "Burgenland"
          },
          {
            "id": "AT-2",
            "name": "Carinthia"
          },
          {
            "id": "AT-3",
            "name": "Lower Austria"
          },
          {
            "id": "AT-5",
            "name": "Salzburg"
          },
          {
            "id": "AT-6",
            "name": "Styria"
          },
          {
            "id": "AT-7",
            "name": "Tyrol"
          },
          {
            "id": "AT-4",
            "name": "Upper Austria"
          },
          {
            "id": "AT-9",
            "name": "Vienna"
          },
          {
            "id": "AT-8",
            "name": "Vorarlberg"
          }
        ],
        "total": 9
      },
      {
        "id": "BE",
        "un": "BE",
        "name": "Belgium",
        "db": [
          {
            "id": "BE-BRU",
            "name": "Brussels-Capital"
          },
          {
            "id": "BE-VLG",
            "name": "Flanders"
          },
          {
            "id": "BE-WAL",
            "name": "Wallonia"
          }
        ],
        "total": 3
      },
      {
        "id": "FR",
        "un": "FR",
        "name": "France",
        "db": [
          {
            "id": "FR-A",
            "name": "Alsace"
          },
          {
            "id": "FR-B",
            "name": "Aquitaine"
          },
          {
            "id": "FR-C",
            "name": "Auvergne"
          },
          {
            "id": "FR-E",
            "name": "Brittany"
          },
          {
            "id": "FR-D",
            "name": "Burgundy"
          },
          {
            "id": "FR-F",
            "name": "Centre-Val de Loire"
          },
          {
            "id": "FR-G",
            "name": "Champagne-Ardenne"
          },
          {
            "id": "FR-H",
            "name": "Corsica"
          },
          {
            "id": "FR-I",
            "name": "Franche-Comté"
          },
          {
            "id": "FR-J",
            "name": "Île-de-France"
          },
          {
            "id": "FR-K",
            "name": "Languedoc-Roussillon"
          },
          {
            "id": "FR-L",
            "name": "Limousin"
          },
          {
            "id": "FR-M",
            "name": "Lorraine"
          },
          {
            "id": "FR-P",
            "name": "Lower Normandy"
          },
          {
            "id": "FR-N",
            "name": "Midi-Pyrénées"
          },
          {
            "id": "FR-O",
            "name": "Nord-Pas-de-Calais"
          },
          {
            "id": "FR-R",
            "name": "Pays de la Loire"
          },
          {
            "id": "FR-S",
            "name": "Picardy"
          },
          {
            "id": "FR-T",
            "name": "Poitou-Charentes"
          },
          {
            "id": "FR-U",
            "name": "Provence-Alpes-Côte d'Azur"
          },
          {
            "id": "FR-V",
            "name": "Rhône-Alpes"
          },
          {
            "id": "FR-Q",
            "name": "Upper Normandy"
          }
        ],
        "total": 22
      },
      {
        "id": "DE",
        "un": "DE",
        "name": "Germany",
        "db": [
          {
            "id": "DE-BW",
            "name": "Baden-Württemberg"
          },
          {
            "id": "DE-BY",
            "name": "Bavaria"
          },
          {
            "id": "DE-BE",
            "name": "Berlin"
          },
          {
            "id": "DE-BB",
            "name": "Brandenburg"
          },
          {
            "id": "DE-HB",
            "name": "Bremen"
          },
          {
            "id": "DE-HH",
            "name": "Hamburg"
          },
          {
            "id": "DE-HE",
            "name": "Hesse"
          },
          {
            "id": "DE-NI",
            "name": "Lower Saxony"
          },
          {
            "id": "DE-MV",
            "name": "Mecklenburg-Vorpommern"
          },
          {
            "id": "DE-NW",
            "name": "North Rhine-Westphalia"
          },
          {
            "id": "DE-RP",
            "name": "Rhineland-Palatinate"
          },
          {
            "id": "DE-SL",
            "name": "Saarland"
          },
          {
            "id": "DE-SN",
            "name": "Saxony"
          },
          {
            "id": "DE-ST",
            "name": "Saxony-Anhalt"
          },
          {
            "id": "DE-SH",
            "name": "Schleswig-Holstein"
          },
          {
            "id": "DE-TH",
            "name": "Thuringia"
          }
        ],
        "total": 16
      },
      {
        "id": "LI",
        "un": "LI",
        "name": "Liechtenstein"
      },
      {
        "id": "LU",
        "un": "LU",
        "name": "Luxembourg"
      },
      {
        "id": "MC",
        "un": "MC",
        "name": "Monaco"
      },
      {
        "id": "NL",
        "un": "NL",
        "name": "Netherlands",
        "db": [
          {
            "id": "NL2",
            "name": "East"
          },
          {
            "id": "NL1",
            "name": "North"
          },
          {
            "id": "NL4",
            "name": "South"
          },
          {
            "id": "NL3",
            "name": "West"
          }
        ],
        "total": 4
      },
      {
        "id": "CH",
        "un": "CH",
        "name": "Switzerland",
        "db": [
          {
            "id": "CH-AG",
            "name": "Aargau"
          },
          {
            "id": "CH-AR",
            "name": "Appenzell Ausserrhoden"
          },
          {
            "id": "CH-AI",
            "name": "Appenzell Innerrhoden"
          },
          {
            "id": "CH-BS",
            "name": "Basel-City"
          },
          {
            "id": "CH-BL",
            "name": "Basel-Landschaft"
          },
          {
            "id": "CH-BE",
            "name": "Bern"
          },
          {
            "id": "CH-FR",
            "name": "Fribourg"
          },
          {
            "id": "CH-GE",
            "name": "Geneva"
          },
          {
            "id": "CH-GL",
            "name": "Glarus"
          },
          {
            "id": "CH-GR",
            "name": "Grisons"
          },
          {
            "id": "CH-JU",
            "name": "Jura"
          },
          {
            "id": "CH-LU",
            "name": "Lucerne"
          },
          {
            "id": "CH-NE",
            "name": "Neuchâtel"
          },
          {
            "id": "CH-NW",
            "name": "Nidwalden"
          },
          {
            "id": "CH-OW",
            "name": "Obwalden"
          },
          {
            "id": "CH-SH",
            "name": "Schaffhausen"
          },
          {
            "id": "CH-SZ",
            "name": "Schwyz"
          },
          {
            "id": "CH-SO",
            "name": "Solothurn"
          },
          {
            "id": "CH-SG",
            "name": "St. Gallen"
          },
          {
            "id": "CH-TG",
            "name": "Thurgau"
          },
          {
            "id": "CH-TI",
            "name": "Ticino"
          },
          {
            "id": "CH-UR",
            "name": "Uri"
          },
          {
            "id": "CH-VD",
            "name": "Vaud"
          },
          {
            "id": "CH-VS",
            "name": "Wallis"
          },
          {
            "id": "CH-ZG",
            "name": "Zug"
          },
          {
            "id": "CH-ZH",
            "name": "Zurich"
          }
        ],
        "total": 26
      }
    ],
    "total": 83
  },
  {
    "id": "EUN",
    "name": "Northern Europe",
    "db": [
      {
        "id": "AX",
        "un": "FI",
        "name": "Åland Islands",
        "db": [
          {
            "id": "AX",
            "name": "Åland Islands"
          }
        ],
        "total": 1
      },
      {
        "id": "DK",
        "un": "DK",
        "name": "Denmark",
        "db": [
          {
            "id": "DK-040",
            "name": "Bornholm"
          },
          {
            "id": "DK-84",
            "name": "Capital Region"
          },
          {
            "id": "DK-82",
            "name": "Central Denmark"
          },
          {
            "id": "DK-81",
            "name": "North Denmark"
          },
          {
            "id": "DK-83",
            "name": "Southern Denmark"
          },
          {
            "id": "DK-85",
            "name": "Zealand"
          }
        ],
        "total": 6
      },
      {
        "id": "EE",
        "un": "EE",
        "name": "Estonia"
      },
      {
        "id": "FO",
        "un": "DK",
        "name": "Faroe Islands"
      },
      {
        "id": "FI",
        "un": "FI",
        "name": "Finland",
        "db": [
          {
            "id": "FI-L",
            "name": "Lakeland"
          },
          {
            "id": "FI-N",
            "name": "Northern Finland"
          },
          {
            "id": "FI-S",
            "name": "Southern Finland"
          },
          {
            "id": "FI-W",
            "name": "West Coast"
          }
        ],
        "total": 4
      },
      {
        "id": "GG",
        "un": "GB",
        "name": "Guernsey"
      },
      {
        "id": "IS",
        "un": "IS",
        "name": "Iceland",
        "db": [
          {
            "id": "IS:E",
            "name": "Eurasian plate"
          },
          {
            "id": "IS:A",
            "name": "North American plate"
          },
          {
            "id": "IS:R",
            "name": "Reykjavík and Reykjanesbær"
          }
        ],
        "total": 3
      },
      {
        "id": "IE",
        "un": "IE",
        "name": "Ireland",
        "db": [
          {
            "id": "IE-C",
            "name": "Connacht"
          },
          {
            "id": "IE-L",
            "name": "Leinster"
          },
          {
            "id": "IE-M",
            "name": "Munster"
          },
          {
            "id": "IE-U",
            "name": "Ulster"
          }
        ],
        "total": 4
      },
      {
        "id": "IM",
        "un": "GB",
        "name": "Isle of Man"
      },
      {
        "id": "JE",
        "un": "GB",
        "name": "Jersey"
      },
      {
        "id": "LV",
        "un": "LV",
        "name": "Latvia"
      },
      {
        "id": "LT",
        "un": "LT",
        "name": "Lithuania"
      },
      {
        "id": "NO",
        "un": "NO",
        "name": "Norway",
        "db": [
          {
            "id": "NO-42",
            "name": "Agder"
          },
          {
            "id": "NO:E",
            "name": "East"
          },
          {
            "id": "NO:N",
            "name": "North"
          },
          {
            "id": "NO-50",
            "name": "Trøndelag"
          },
          {
            "id": "NO:W",
            "name": "West"
          }
        ],
        "total": 5
      },
      {
        "id": "SJ",
        "un": "NO",
        "name": "Svalbard and Jan Mayen",
        "db": [
          {
            "id": "SJ-2",
            "name": "Jan Mayen"
          },
          {
            "id": "NO-21",
            "name": "Svalbard"
          }
        ],
        "total": 2
      },
      {
        "id": "SE",
        "un": "SE",
        "name": "Sweden",
        "db": [
          {
            "id": "SE3",
            "name": "Götaland"
          },
          {
            "id": "SE-I",
            "name": "Gotland"
          },
          {
            "id": "SE1",
            "name": "Norrland"
          },
          {
            "id": "SE2",
            "name": "Svealand"
          }
        ],
        "total": 4
      },
      {
        "id": "GB",
        "un": "GB",
        "name": "United Kingdom",
        "db": [
          {
            "id": "GB-1EM",
            "name": "England - East Midlands"
          },
          {
            "id": "GB-1EE",
            "name": "England - East of"
          },
          {
            "id": "GB-IOS",
            "name": "England - Isles of Scilly"
          },
          {
            "id": "GB-1L",
            "name": "England - London"
          },
          {
            "id": "GB-1NE",
            "name": "England - North East"
          },
          {
            "id": "GB-1NW",
            "name": "England - North West"
          },
          {
            "id": "GB-1SE",
            "name": "England - South East"
          },
          {
            "id": "GB-1SW",
            "name": "England - South West"
          },
          {
            "id": "GB-1WM",
            "name": "England - West Midlands"
          },
          {
            "id": "GB-1YH",
            "name": "England - Yorkshire and the Humber"
          },
          {
            "id": "GB-NIR",
            "name": "Northern Ireland"
          },
          {
            "id": "GB-2H",
            "name": "Scotland - Highlands"
          },
          {
            "id": "GB-2L",
            "name": "Scotland - Lowlands"
          },
          {
            "id": "GB-ORK",
            "name": "Scotland - Orkney Islands"
          },
          {
            "id": "GB-ELS",
            "name": "Scotland - Outer Hebrides"
          },
          {
            "id": "GB-ZET",
            "name": "Scotland - Shetland Islands"
          },
          {
            "id": "GB-3W",
            "name": "Wales"
          },
          {
            "id": "GB-AGY",
            "name": "Wales - Isle of Anglesey"
          }
        ],
        "total": 18
      }
    ],
    "total": 54
  },
  {
    "id": "EUS",
    "name": "Southern Europe",
    "db": [
      {
        "id": "AL",
        "un": "AL",
        "name": "Albania"
      },
      {
        "id": "AD",
        "un": "AD",
        "name": "Andorra"
      },
      {
        "id": "BA",
        "un": "BA",
        "name": "Bosnia and Herzegovina",
        "db": [
          {
            "id": "BA-BRC",
            "name": "Brčko District"
          },
          {
            "id": "BA-BIH",
            "name": "Federation of Bosnia and Herzegovina"
          },
          {
            "id": "BA-SRP",
            "name": "Republika Srpska"
          }
        ],
        "total": 3
      },
      {
        "id": "HR",
        "un": "HR",
        "name": "Croatia",
        "db": [
          {
            "id": "HR:D",
            "name": "Dalmacija"
          },
          {
            "id": "HR-18",
            "name": "Istria"
          },
          {
            "id": "HR:K",
            "name": "Kvarner"
          },
          {
            "id": "HR:S",
            "name": "Slavonija"
          },
          {
            "id": "HR:C",
            "name": "Središnja Hrvatska"
          }
        ],
        "total": 5
      },
      {
        "id": "GI",
        "un": "GB",
        "name": "Gibraltar"
      },
      {
        "id": "GR",
        "un": "GR",
        "name": "Greece",
        "db": [
          {
            "id": "GR-K",
            "name": "Athos"
          },
          {
            "id": "GR-L",
            "name": "Athos"
          },
          {
            "id": "GR-69",
            "name": "Athos"
          },
          {
            "id": "GR:CNT",
            "name": "Central"
          },
          {
            "id": "GR-M",
            "name": "Crete"
          },
          {
            "id": "GR-F",
            "name": "Ioanian Islands"
          },
          {
            "id": "GR:NOR",
            "name": "North"
          },
          {
            "id": "GR:PEL",
            "name": "Peloponnese"
          }
        ],
        "total": 8
      },
      {
        "id": "VA",
        "un": "ZZ",
        "name": "Holy See"
      },
      {
        "id": "IT",
        "un": "IT",
        "name": "Italy",
        "db": [
          {
            "id": "IT-65",
            "name": "Abruzzo"
          },
          {
            "id": "IT-23",
            "name": "Aosta Valley"
          },
          {
            "id": "IT-75",
            "name": "Apulia"
          },
          {
            "id": "IT-77",
            "name": "Basilicata"
          },
          {
            "id": "IT-78",
            "name": "Calabria"
          },
          {
            "id": "IT-72",
            "name": "Campania"
          },
          {
            "id": "IT-45",
            "name": "Emilia-Romagna"
          },
          {
            "id": "IT-36",
            "name": "Friuli-Venezia Giulia"
          },
          {
            "id": "IT-62",
            "name": "Lazio"
          },
          {
            "id": "IT-42",
            "name": "Liguria"
          },
          {
            "id": "IT-25",
            "name": "Lombardy"
          },
          {
            "id": "IT-57",
            "name": "Marche"
          },
          {
            "id": "IT-67",
            "name": "Molise"
          },
          {
            "id": "IT:PP",
            "name": "Pantelleria, Lampedusa e Linosa"
          },
          {
            "id": "IT-21",
            "name": "Piedmont"
          },
          {
            "id": "IT-88",
            "name": "Sardinia"
          },
          {
            "id": "IT-82",
            "name": "Sicily"
          },
          {
            "id": "IT-32",
            "name": "Trentino-Alto Adige/Südtirol"
          },
          {
            "id": "IT-52",
            "name": "Tuscany"
          },
          {
            "id": "IT-55",
            "name": "Umbria"
          },
          {
            "id": "IT-34",
            "name": "Veneto"
          }
        ],
        "total": 21
      },
      {
        "id": "XK",
        "un": "RS",
        "name": "Kosovo"
      },
      {
        "id": "MT",
        "un": "MT",
        "name": "Malta",
        "db": [
          {
            "id": "MT:G",
            "name": "Gozo"
          },
          {
            "id": "MT:M",
            "name": "Malta"
          }
        ],
        "total": 2
      },
      {
        "id": "ME",
        "un": "ME",
        "name": "Montenegro",
        "db": [
          {
            "id": "ME:C",
            "name": "Central"
          },
          {
            "id": "ME:M",
            "name": "North Montenegrin Mountains"
          },
          {
            "id": "ME:R",
            "name": "Riviera"
          }
        ],
        "total": 3
      },
      {
        "id": "MK",
        "un": "MK",
        "name": "North Macedonia"
      },
      {
        "id": "PT",
        "un": "PT",
        "name": "Portugal",
        "db": [
          {
            "id": "PT:A",
            "name": "Alentejo Region"
          },
          {
            "id": "PT-08",
            "name": "Algarve"
          },
          {
            "id": "PT:C",
            "name": "Central"
          },
          {
            "id": "PT-11",
            "name": "Lisbon"
          },
          {
            "id": "PT:N",
            "name": "North"
          }
        ],
        "total": 5
      },
      {
        "id": "SM",
        "un": "SM",
        "name": "San Marino"
      },
      {
        "id": "RS",
        "un": "RS",
        "name": "Serbia",
        "db": [
          {
            "id": "RS-00",
            "name": "City of Belgrade"
          },
          {
            "id": "RS:W",
            "name": "Podrinje"
          },
          {
            "id": "RS:P",
            "name": "Podunavlje"
          },
          {
            "id": "RS:S",
            "name": "Šumadija"
          },
          {
            "id": "RS-VO",
            "name": "Vojvodina"
          }
        ],
        "total": 5
      },
      {
        "id": "SI",
        "un": "SI",
        "name": "Slovenia"
      },
      {
        "id": "ES",
        "un": "ES",
        "name": "Spain",
        "db": [
          {
            "id": "ES-AN",
            "name": "Andalusia"
          },
          {
            "id": "ES-AR",
            "name": "Aragon"
          },
          {
            "id": "ES-AS",
            "name": "Asturias"
          },
          {
            "id": "ES-IB",
            "name": "Balearic Islands"
          },
          {
            "id": "ES-PV",
            "name": "Basque Country"
          },
          {
            "id": "ES-CB",
            "name": "Cantabria"
          },
          {
            "id": "ES-CL",
            "name": "Castile and León"
          },
          {
            "id": "ES-CM",
            "name": "Castile-La Mancha"
          },
          {
            "id": "ES-CT",
            "name": "Catalonia"
          },
          {
            "id": "ES-MD",
            "name": "Community of Madrid"
          },
          {
            "id": "ES-EX",
            "name": "Extremadura"
          },
          {
            "id": "ES-GA",
            "name": "Galicia"
          },
          {
            "id": "ES-NC",
            "name": "Navarre"
          },
          {
            "id": "ES-MC",
            "name": "Region of Murcia"
          },
          {
            "id": "ES-RI",
            "name": "Rioja"
          },
          {
            "id": "ES-VC",
            "name": "Valencian Community"
          }
        ],
        "total": 16
      }
    ],
    "total": 76
  },
  {
    "id": "EUE",
    "name": "Eastern Europe",
    "db": [
      {
        "id": "BY",
        "un": "BY",
        "name": "Belarus",
        "db": [
          {
            "id": "BY:E",
            "name": "East"
          },
          {
            "id": "BY-HM",
            "name": "Minsk"
          },
          {
            "id": "BY:W",
            "name": "West"
          }
        ],
        "total": 3
      },
      {
        "id": "BG",
        "un": "BG",
        "name": "Bulgaria",
        "db": [
          {
            "id": "BG3",
            "name": "Black Sea"
          },
          {
            "id": "BG1",
            "name": "Danubian Plain"
          },
          {
            "id": "BG0",
            "name": "Shopluk"
          },
          {
            "id": "BG2",
            "name": "Thracian Valley"
          }
        ],
        "total": 4
      },
      {
        "id": "CZ",
        "un": "CZ",
        "name": "Czechia",
        "db": [
          {
            "id": "CZ:B",
            "name": "Bohemia"
          },
          {
            "id": "CZ-63",
            "name": "Kraj Vysočina"
          },
          {
            "id": "CZ:M",
            "name": "Moravia"
          },
          {
            "id": "CZ-80",
            "name": "Moravskoslezský kraj"
          }
        ],
        "total": 4
      },
      {
        "id": "HU",
        "un": "HU",
        "name": "Hungary",
        "db": [
          {
            "id": "HU1",
            "name": "Central Hungary"
          },
          {
            "id": "HU4",
            "name": "Great Plain"
          },
          {
            "id": "HU3",
            "name": "Northern Hungary"
          },
          {
            "id": "HU2",
            "name": "Transdanubia"
          }
        ],
        "total": 4
      },
      {
        "id": "MD",
        "un": "MD",
        "name": "Moldova",
        "db": [
          {
            "id": "MD-GA",
            "name": "Gagauzia"
          },
          {
            "id": "MD1",
            "name": "Moldova"
          }
        ],
        "total": 2
      },
      {
        "id": "PL",
        "un": "PL",
        "name": "Poland",
        "db": [
          {
            "id": "PL:G",
            "name": "Greater Poland"
          },
          {
            "id": "PL:L",
            "name": "Lesser Poland"
          },
          {
            "id": "PL:M",
            "name": "Masovia"
          },
          {
            "id": "PL-20",
            "name": "Podlasie"
          },
          {
            "id": "PL:P",
            "name": "Pomerania"
          },
          {
            "id": "PL:S",
            "name": "Silesia"
          },
          {
            "id": "PL-28",
            "name": "Warmia-Masuria"
          }
        ],
        "total": 7
      },
      {
        "id": "RO",
        "un": "RO",
        "name": "Romania",
        "db": [
          {
            "id": "RO:B",
            "name": "Banat"
          },
          {
            "id": "RO-SV",
            "name": "Bucovina"
          },
          {
            "id": "RO:C",
            "name": "Crișana"
          },
          {
            "id": "RO:D",
            "name": "Dobrogea"
          },
          {
            "id": "RO:MA",
            "name": "Maramureș"
          },
          {
            "id": "RO:MD",
            "name": "Moldova"
          },
          {
            "id": "RO:MU",
            "name": "Muntenia"
          },
          {
            "id": "RO:O",
            "name": "Oltenia"
          },
          {
            "id": "RO:T",
            "name": "Transylvania"
          }
        ],
        "total": 9
      },
      {
        "id": "RU",
        "un": "RU",
        "name": "Russian Federation",
        "db": [
          {
            "id": "RU-ARK",
            "name": "Arkhangelsk Oblast"
          },
          {
            "id": "RU-AST",
            "name": "Astrakhan Oblast"
          },
          {
            "id": "RU-BA",
            "name": "Bashkortostan"
          },
          {
            "id": "RU-BEL",
            "name": "Belgorod Oblast"
          },
          {
            "id": "RU-BRY",
            "name": "Bryansk Oblast"
          },
          {
            "id": "RU-CE",
            "name": "Chechnya"
          },
          {
            "id": "RU-CU",
            "name": "Chuvashia"
          },
          {
            "id": "RU:CR",
            "name": "Crimea"
          },
          {
            "id": "RU-DA",
            "name": "Dagestan"
          },
          {
            "id": "RU-IN",
            "name": "Ingushetia"
          },
          {
            "id": "RU-IVA",
            "name": "Ivanovo Oblast"
          },
          {
            "id": "RU-KB",
            "name": "Kabardino-Balkaria"
          },
          {
            "id": "RU-KGD",
            "name": "Kaliningrad"
          },
          {
            "id": "RU-KLU",
            "name": "Kaluga Oblast"
          },
          {
            "id": "RU-KC",
            "name": "Karachay-Cherkessia"
          },
          {
            "id": "RU-KIR",
            "name": "Kirov Oblast"
          },
          {
            "id": "RU-KO",
            "name": "Komi Republic"
          },
          {
            "id": "RU-KOS",
            "name": "Kostroma Oblast"
          },
          {
            "id": "RU-KDA",
            "name": "Krasnodar Krai"
          },
          {
            "id": "RU-KRS",
            "name": "Kursk Oblast"
          },
          {
            "id": "RU-LEN",
            "name": "Leningrad oblast"
          },
          {
            "id": "RU-LIP",
            "name": "Lipetsk Oblast"
          },
          {
            "id": "RU-ME",
            "name": "Mari El Republic"
          },
          {
            "id": "RU-MOW",
            "name": "Moscow"
          },
          {
            "id": "RU-MOS",
            "name": "Moscow Oblast"
          },
          {
            "id": "RU-MUR",
            "name": "Murmansk Oblast"
          },
          {
            "id": "RU-NEN",
            "name": "Nenets Autonomous Okrug"
          },
          {
            "id": "RU-NIZ",
            "name": "Nizhny Novgorod Oblast"
          },
          {
            "id": "RU-NGR",
            "name": "Novgorod Oblast"
          },
          {
            "id": "RU-ORE",
            "name": "Orenburg Oblast"
          },
          {
            "id": "RU-ORL",
            "name": "Oryol Oblast"
          },
          {
            "id": "RU-PNZ",
            "name": "Penza Oblast"
          },
          {
            "id": "RU-PER",
            "name": "Perm Krai"
          },
          {
            "id": "RU-PSK",
            "name": "Pskov Oblast"
          },
          {
            "id": "RU-AD",
            "name": "Republic of Adygea"
          },
          {
            "id": "RU-KL",
            "name": "Republic of Kalmykia"
          },
          {
            "id": "RU-KR",
            "name": "Republic of Karelia"
          },
          {
            "id": "RU-MO",
            "name": "Republic of Mordovia"
          },
          {
            "id": "RU-SE",
            "name": "Republic of North Ossetia – Alania"
          },
          {
            "id": "RU-ROS",
            "name": "Rostov Oblast"
          },
          {
            "id": "RU-RYA",
            "name": "Ryazan Oblast"
          },
          {
            "id": "RU-SPE",
            "name": "Saint Petersburg"
          },
          {
            "id": "RU-SAM",
            "name": "Samara Oblast"
          },
          {
            "id": "RU-SAR",
            "name": "Saratov Oblast"
          },
          {
            "id": "RU-SMO",
            "name": "Smolensk Oblast"
          },
          {
            "id": "RU-STA",
            "name": "Stavropol Krai"
          },
          {
            "id": "RU-TAM",
            "name": "Tambov Oblast"
          },
          {
            "id": "RU-TA",
            "name": "Tatarstan"
          },
          {
            "id": "RU-TUL",
            "name": "Tula Oblast"
          },
          {
            "id": "RU-TVE",
            "name": "Tver Oblast"
          },
          {
            "id": "RU-UD",
            "name": "Udmurtia"
          },
          {
            "id": "RU-ULY",
            "name": "Ulyanovsk Oblast"
          },
          {
            "id": "RU-VLA",
            "name": "Vladimir Oblast"
          },
          {
            "id": "RU-VGG",
            "name": "Volgograd Oblast"
          },
          {
            "id": "RU-VLG",
            "name": "Vologda Oblast"
          },
          {
            "id": "RU-VOR",
            "name": "Voronezh Oblast"
          },
          {
            "id": "RU-YAR",
            "name": "Yaroslavl Oblast"
          }
        ],
        "total": 57
      },
      {
        "id": "SK",
        "un": "SK",
        "name": "Slovakia",
        "db": [
          {
            "id": "SK:C",
            "name": "Central"
          },
          {
            "id": "SK:E",
            "name": "East"
          },
          {
            "id": "SK:W",
            "name": "West"
          }
        ],
        "total": 3
      },
      {
        "id": "XT",
        "un": "MD",
        "name": "Transnistria",
        "db": [
          {
            "id": "XT",
            "name": "Transnistria"
          }
        ],
        "total": 1
      },
      {
        "id": "UA",
        "un": "UA",
        "name": "Ukraine",
        "db": [
          {
            "id": "UA-71",
            "name": "Cherkasy Oblast"
          },
          {
            "id": "UA-74",
            "name": "Chernihiv Oblast"
          },
          {
            "id": "UA-77",
            "name": "Chernivtsi Oblast"
          },
          {
            "id": "UA-12",
            "name": "Dnipropetrovsk Oblast"
          },
          {
            "id": "UA-14",
            "name": "Donetsk Oblast"
          },
          {
            "id": "UA-26",
            "name": "Ivano-Frankivsk Oblast"
          },
          {
            "id": "UA-63",
            "name": "Kharkiv Oblast"
          },
          {
            "id": "UA-65",
            "name": "Kherson Oblast"
          },
          {
            "id": "UA-68",
            "name": "Khmelnytskyi Oblast"
          },
          {
            "id": "UA-35",
            "name": "Kirovohrad Oblast"
          },
          {
            "id": "UA-K",
            "name": "Kyiv and Kyiv Oblast"
          },
          {
            "id": "UA-09",
            "name": "Luhansk Oblast"
          },
          {
            "id": "UA-46",
            "name": "Lviv Oblast"
          },
          {
            "id": "UA-48",
            "name": "Mykolaiv Oblast"
          },
          {
            "id": "UA-51",
            "name": "Odesa Oblast"
          },
          {
            "id": "UA-53",
            "name": "Poltava Oblast"
          },
          {
            "id": "UA-56",
            "name": "Rivne Oblast"
          },
          {
            "id": "UA-59",
            "name": "Sumy Oblast"
          },
          {
            "id": "UA-61",
            "name": "Ternopil Oblast"
          },
          {
            "id": "UA-05",
            "name": "Vinnytsia Oblast"
          },
          {
            "id": "UA-07",
            "name": "Volyn Oblast"
          },
          {
            "id": "UA-21",
            "name": "Zakarpattia Oblast"
          },
          {
            "id": "UA-23",
            "name": "Zaporizhia Oblast"
          },
          {
            "id": "UA-18",
            "name": "Zhytomyr Oblast"
          }
        ],
        "total": 24
      }
    ],
    "total": 118
  },
  {
    "id": "AFN",
    "name": "Northern Africa",
    "db": [
      {
        "id": "DZ",
        "un": "DZ",
        "name": "Algeria",
        "db": [
          {
            "id": "DZ:C",
            "name": "Central"
          },
          {
            "id": "DZ:NE",
            "name": "Northeast"
          },
          {
            "id": "DZ:NW",
            "name": "Northwest"
          },
          {
            "id": "DZ:S",
            "name": "Sahara"
          },
          {
            "id": "DZ:A",
            "name": "Saharan Atlas"
          }
        ],
        "total": 5
      },
      {
        "id": "EG",
        "un": "EG",
        "name": "Egypt",
        "db": [
          {
            "id": "EG:L",
            "name": "Lower Egypt"
          },
          {
            "id": "EG-MT",
            "name": "Matruh"
          },
          {
            "id": "EG:M",
            "name": "Middle Egypt"
          },
          {
            "id": "EG-BA",
            "name": "Red Sea"
          },
          {
            "id": "EG:S",
            "name": "Sinai"
          },
          {
            "id": "EG:U",
            "name": "Upper Egypt"
          },
          {
            "id": "EG-WAD",
            "name": "Western Desert"
          }
        ],
        "total": 7
      },
      {
        "id": "LY",
        "un": "LY",
        "name": "Libya",
        "db": [
          {
            "id": "LY-C",
            "name": "Cyrenaica"
          },
          {
            "id": "LY-S",
            "name": "Saharan Libya"
          },
          {
            "id": "LY-T",
            "name": "Tripolitania"
          }
        ],
        "total": 3
      },
      {
        "id": "MA",
        "un": "MA",
        "name": "Morocco",
        "db": [
          {
            "id": "MA:AA",
            "name": "Anti Atlas"
          },
          {
            "id": "MA-03",
            "name": "Fez-Meknes"
          },
          {
            "id": "MA:HA",
            "name": "High Atlas"
          },
          {
            "id": "MA:MM",
            "name": "Mediterranean Coast"
          },
          {
            "id": "MA:NA",
            "name": "North Atlantic Coast"
          },
          {
            "id": "MA:SM",
            "name": "Sahara"
          },
          {
            "id": "MA:SA",
            "name": "South Atlantic Coast"
          },
          {
            "id": "MA:WS",
            "name": "Western Sahara"
          }
        ],
        "total": 8
      },
      {
        "id": "ES",
        "un": "ES",
        "name": "Spain",
        "db": [
          {
            "id": "ES-CE",
            "name": "Ceuta"
          },
          {
            "id": "ES-ML",
            "name": "Melilla"
          }
        ],
        "total": 2
      },
      {
        "id": "SD",
        "un": "SD",
        "name": "Sudan",
        "db": [
          {
            "id": "SD-C",
            "name": "Central Sudan"
          },
          {
            "id": "SD-D",
            "name": "Darfur"
          },
          {
            "id": "SD-E",
            "name": "Eastern Sudan"
          },
          {
            "id": "SD-K",
            "name": "Kurdufan"
          },
          {
            "id": "SD-N",
            "name": "Northern Sudan"
          }
        ],
        "total": 5
      },
      {
        "id": "TN",
        "un": "TN",
        "name": "Tunisia",
        "db": [
          {
            "id": "TN2",
            "name": "Central Coastal Tunisia"
          },
          {
            "id": "TN1",
            "name": "Northern Tunisia"
          },
          {
            "id": "TN3",
            "name": "Saharan Tunisia"
          }
        ],
        "total": 3
      },
      {
        "id": "EH",
        "un": "ZZ",
        "name": "Western Sahara"
      }
    ],
    "total": 34
  },
  {
    "id": "AFW",
    "name": "Western Africa",
    "db": [
      {
        "id": "BJ",
        "un": "BJ",
        "name": "Benin"
      },
      {
        "id": "BF",
        "un": "BF",
        "name": "Burkina Faso",
        "db": [
          {
            "id": "BF-BV",
            "name": "Black Volta"
          },
          {
            "id": "BF-E",
            "name": "East"
          },
          {
            "id": "BF-N",
            "name": "Sahelian Burkina Faso"
          },
          {
            "id": "BF-VD",
            "name": "Volta Delta"
          }
        ],
        "total": 4
      },
      {
        "id": "CV",
        "un": "CV",
        "name": "Cabo Verde",
        "db": [
          {
            "id": "CV-B",
            "name": "Barlavento Islands"
          },
          {
            "id": "CV-S",
            "name": "Sotavento Islands"
          }
        ],
        "total": 2
      },
      {
        "id": "CI",
        "un": "CI",
        "name": "Côte d'Ivoire",
        "db": [
          {
            "id": "CI:EP",
            "name": "Eastern Plantations"
          },
          {
            "id": "CI:LG",
            "name": "Lagunes"
          },
          {
            "id": "CI:NS",
            "name": "Northern Savanna"
          },
          {
            "id": "CI:SF",
            "name": "Southwestern Forests"
          }
        ],
        "total": 4
      },
      {
        "id": "GM",
        "un": "GM",
        "name": "Gambia"
      },
      {
        "id": "GH",
        "un": "GH",
        "name": "Ghana",
        "db": [
          {
            "id": "GH:A",
            "name": "Ashanti-Kwahu"
          },
          {
            "id": "GH:C",
            "name": "Coastal Plain"
          },
          {
            "id": "GH:N",
            "name": "Northern Plains"
          },
          {
            "id": "GH:V",
            "name": "Volta Basin"
          }
        ],
        "total": 4
      },
      {
        "id": "GN",
        "un": "GN",
        "name": "Guinea",
        "db": [
          {
            "id": "GN:GF",
            "name": "Guinée Forestière"
          },
          {
            "id": "GN:MR",
            "name": "Guinée Maritime"
          },
          {
            "id": "GN:HG",
            "name": "Haute-Guinée"
          },
          {
            "id": "GN:MG",
            "name": "Moyenne-Guinée"
          }
        ],
        "total": 4
      },
      {
        "id": "GW",
        "un": "GW",
        "name": "Guinea-Bissau",
        "db": [
          {
            "id": "GW:B",
            "name": "Arquipélago dos Bijagós"
          },
          {
            "id": "GW:0",
            "name": "Guinea-Bissau proper"
          }
        ],
        "total": 2
      },
      {
        "id": "LR",
        "un": "LR",
        "name": "Liberia"
      },
      {
        "id": "ML",
        "un": "ML",
        "name": "Mali",
        "db": [
          {
            "id": "ML:N",
            "name": "North"
          },
          {
            "id": "ML:S",
            "name": "South"
          }
        ],
        "total": 2
      },
      {
        "id": "MR",
        "un": "MR",
        "name": "Mauritania",
        "db": [
          {
            "id": "MR-1",
            "name": "Coastal Mauritania"
          },
          {
            "id": "MR-3",
            "name": "Saharan Mauritania"
          },
          {
            "id": "MR-2",
            "name": "Sahelian Mauritania"
          }
        ],
        "total": 3
      },
      {
        "id": "NE",
        "un": "NE",
        "name": "Niger",
        "db": [
          {
            "id": "NE-1",
            "name": "Agadez"
          },
          {
            "id": "NE-S",
            "name": "Sahelian Niger"
          },
          {
            "id": "NE-W",
            "name": "Southwestern Niger"
          }
        ],
        "total": 3
      },
      {
        "id": "NG",
        "un": "NG",
        "name": "Nigeria",
        "db": [
          {
            "id": "NG-SSZ",
            "name": "Niger Delta region"
          },
          {
            "id": "NG-NCZ",
            "name": "North Central Nigeria"
          },
          {
            "id": "NG-NEZ",
            "name": "North East Nigeria"
          },
          {
            "id": "NG-NWZ",
            "name": "North West Nigeria"
          },
          {
            "id": "NG-SEZ",
            "name": "South East Nigeria"
          },
          {
            "id": "NG-SWZ",
            "name": "South West Nigeria"
          }
        ],
        "total": 6
      },
      {
        "id": "SN",
        "un": "SN",
        "name": "Senegal"
      },
      {
        "id": "SL",
        "un": "SL",
        "name": "Sierra Leone",
        "db": [
          {
            "id": "SL2",
            "name": "North and East"
          },
          {
            "id": "SL1",
            "name": "West and South"
          }
        ],
        "total": 2
      },
      {
        "id": "TG",
        "un": "TG",
        "name": "Togo"
      }
    ],
    "total": 41
  },
  {
    "id": "AFE",
    "name": "Eastern Africa",
    "db": [
      {
        "id": "BI",
        "un": "BI",
        "name": "Burundi"
      },
      {
        "id": "KM",
        "un": "KM",
        "name": "Comoros"
      },
      {
        "id": "DJ",
        "un": "DJ",
        "name": "Djibouti"
      },
      {
        "id": "ER",
        "un": "ER",
        "name": "Eritrea"
      },
      {
        "id": "ET",
        "un": "ET",
        "name": "Ethiopia",
        "db": [
          {
            "id": "ET-AA",
            "name": "Addis Ababa"
          },
          {
            "id": "ET-AF",
            "name": "Afar Region"
          },
          {
            "id": "ET-AM",
            "name": "Amhara Region"
          },
          {
            "id": "ET-BE",
            "name": "Benishangul-Gumuz Region"
          },
          {
            "id": "ET-GA",
            "name": "Gambela Region"
          },
          {
            "id": "ET:1",
            "name": "Harar and Dire Dawa"
          },
          {
            "id": "ET-OR",
            "name": "Oromia Region"
          },
          {
            "id": "ET-SI",
            "name": "Sidama"
          },
          {
            "id": "ET-SO",
            "name": "Somali Region"
          },
          {
            "id": "ET-SW",
            "name": "South West Ethiopia Peoples"
          },
          {
            "id": "ET-SN",
            "name": "Southern Nations, Nationalities, and Peoples"
          },
          {
            "id": "ET-TI",
            "name": "Tigray"
          }
        ],
        "total": 12
      },
      {
        "id": "KE",
        "un": "KE",
        "name": "Kenya",
        "db": [
          {
            "id": "KE-200",
            "name": "Central"
          },
          {
            "id": "KE-300",
            "name": "Coast"
          },
          {
            "id": "KE-400",
            "name": "Eastern"
          },
          {
            "id": "KE-30",
            "name": "Nairobi County"
          },
          {
            "id": "KE-500",
            "name": "North-Eastern"
          },
          {
            "id": "KE-700",
            "name": "Rift Valley"
          },
          {
            "id": "KE-W",
            "name": "Western Kenya"
          }
        ],
        "total": 7
      },
      {
        "id": "MG",
        "un": "MG",
        "name": "Madagascar",
        "db": [
          {
            "id": "MG-T",
            "name": "Antananarivo"
          },
          {
            "id": "MG-D",
            "name": "Antsiranana"
          },
          {
            "id": "MG-F",
            "name": "Fianarantsoa"
          },
          {
            "id": "MG-M",
            "name": "Mahajanga"
          },
          {
            "id": "MG-A",
            "name": "Toamasina"
          },
          {
            "id": "MG-U",
            "name": "Toliara"
          }
        ],
        "total": 6
      },
      {
        "id": "MW",
        "un": "MW",
        "name": "Malawi",
        "db": [
          {
            "id": "MW-C",
            "name": "Central"
          },
          {
            "id": "MW-N",
            "name": "Northern"
          },
          {
            "id": "MW-S",
            "name": "Southern"
          }
        ],
        "total": 3
      },
      {
        "id": "MZ",
        "un": "MZ",
        "name": "Mozambique",
        "db": [
          {
            "id": "MZ2",
            "name": "Central Mozambique"
          },
          {
            "id": "MZ3",
            "name": "Northern Mozambique"
          },
          {
            "id": "MZ1",
            "name": "Southern Mozambique"
          }
        ],
        "total": 3
      },
      {
        "id": "RW",
        "un": "RW",
        "name": "Rwanda"
      },
      {
        "id": "SO",
        "un": "SO",
        "name": "Somalia",
        "db": [
          {
            "id": "SO-P",
            "name": "Puntland"
          },
          {
            "id": "SO1",
            "name": "Southern Somalia"
          }
        ],
        "total": 2
      },
      {
        "id": "XS",
        "un": "SO",
        "name": "Somaliland",
        "db": [
          {
            "id": "XS",
            "name": "Somaliland"
          }
        ],
        "total": 1
      },
      {
        "id": "SS",
        "un": "SS",
        "name": "South Sudan",
        "db": [
          {
            "id": "SS-B",
            "name": "Bahr el Ghazal"
          },
          {
            "id": "SS-E",
            "name": "Equatoria"
          },
          {
            "id": "SS-G",
            "name": "Greater Upper Nile"
          }
        ],
        "total": 3
      },
      {
        "id": "TZ",
        "un": "TZ",
        "name": "Tanzania",
        "db": [
          {
            "id": "TZ-C",
            "name": "Central"
          },
          {
            "id": "TZ-NE",
            "name": "Northeast"
          },
          {
            "id": "TZ-NW",
            "name": "Northwest"
          },
          {
            "id": "TZ-P",
            "name": "Pemba"
          },
          {
            "id": "TZ-SH",
            "name": "Southern Highlands"
          },
          {
            "id": "TZ-IO",
            "name": "Tanzanian Coast"
          },
          {
            "id": "TZ-Z",
            "name": "Zanzibar"
          }
        ],
        "total": 7
      },
      {
        "id": "UG",
        "un": "UG",
        "name": "Uganda",
        "db": [
          {
            "id": "UG-C",
            "name": "Central Region"
          },
          {
            "id": "UG-E",
            "name": "Eastern Region"
          },
          {
            "id": "UG-N",
            "name": "Northern Region"
          },
          {
            "id": "UG-W",
            "name": "Western Region"
          }
        ],
        "total": 4
      },
      {
        "id": "ZW",
        "un": "ZW",
        "name": "Zimbabwe",
        "db": [
          {
            "id": "ZW:MS",
            "name": "Mashonaland"
          },
          {
            "id": "ZW:MT",
            "name": "Matabeleland"
          },
          {
            "id": "ZW:SE",
            "name": "Southeast"
          }
        ],
        "total": 3
      }
    ],
    "total": 56
  },
  {
    "id": "AFM",
    "name": "Middle Africa",
    "db": [
      {
        "id": "AO",
        "un": "AO",
        "name": "Angola",
        "db": [
          {
            "id": "AO-CAB",
            "name": "Cabinda"
          },
          {
            "id": "AO-C",
            "name": "Central Angola"
          },
          {
            "id": "AO-E",
            "name": "Eastern Angola"
          },
          {
            "id": "AO-L",
            "name": "Greater Luanda"
          },
          {
            "id": "AO-N",
            "name": "Northern Angola"
          },
          {
            "id": "AO-S",
            "name": "Southwest Angola"
          }
        ],
        "total": 6
      },
      {
        "id": "CM",
        "un": "CM",
        "name": "Cameroon",
        "db": [
          {
            "id": "CM-AD",
            "name": "Adamawa"
          },
          {
            "id": "CM2",
            "name": "Anglophone"
          },
          {
            "id": "CM3",
            "name": "Coast"
          },
          {
            "id": "CM1",
            "name": "North"
          },
          {
            "id": "CM4",
            "name": "South Cameroon Plateau"
          }
        ],
        "total": 5
      },
      {
        "id": "CF",
        "un": "CF",
        "name": "Central African Republic",
        "db": [
          {
            "id": "CF-E",
            "name": "East"
          },
          {
            "id": "CF-N",
            "name": "Northwest"
          },
          {
            "id": "CF-S",
            "name": "Southwest"
          }
        ],
        "total": 3
      },
      {
        "id": "TD",
        "un": "TD",
        "name": "Chad",
        "db": [
          {
            "id": "TD-1",
            "name": "Saharan Chad"
          },
          {
            "id": "TD-2",
            "name": "Sahelian Chad"
          },
          {
            "id": "TD-3",
            "name": "Soudanian Chad"
          }
        ],
        "total": 3
      },
      {
        "id": "CG",
        "un": "CG",
        "name": "Congo-Brazzaville",
        "db": [
          {
            "id": "CG-CM",
            "name": "Coast and Mayombe"
          },
          {
            "id": "CG-C",
            "name": "Cuvette"
          },
          {
            "id": "CG-NV",
            "name": "Niari Valley"
          },
          {
            "id": "CG-N",
            "name": "Northern Congo"
          },
          {
            "id": "CG-14",
            "name": "Plateaux"
          },
          {
            "id": "CG-P",
            "name": "Pool"
          }
        ],
        "total": 6
      },
      {
        "id": "CD",
        "un": "CD",
        "name": "Congo-Kinshasa",
        "db": [
          {
            "id": "CD-2",
            "name": "Congo Basin"
          },
          {
            "id": "CD-4",
            "name": "Kasai"
          },
          {
            "id": "CD-5",
            "name": "Katanga"
          },
          {
            "id": "CD-3",
            "name": "Kivu"
          },
          {
            "id": "CD-1",
            "name": "West"
          }
        ],
        "total": 5
      },
      {
        "id": "GQ",
        "un": "GQ",
        "name": "Equatorial Guinea",
        "db": [
          {
            "id": "GQ-AN",
            "name": "Annobón"
          },
          {
            "id": "GQ-I",
            "name": "Bioko"
          },
          {
            "id": "GQ-C",
            "name": "Región Continental"
          }
        ],
        "total": 3
      },
      {
        "id": "GA",
        "un": "GA",
        "name": "Gabon",
        "db": [
          {
            "id": "GA-H",
            "name": "Central Highlands"
          },
          {
            "id": "GA-C",
            "name": "Coastal Plain"
          },
          {
            "id": "GA-J",
            "name": "Jungle Interior"
          }
        ],
        "total": 3
      },
      {
        "id": "ST",
        "un": "ST",
        "name": "Sao Tome and Principe",
        "db": [
          {
            "id": "ST-P",
            "name": "Príncipe"
          },
          {
            "id": "ST-ST",
            "name": "São Tomé"
          }
        ],
        "total": 2
      }
    ],
    "total": 36
  },
  {
    "id": "AFS",
    "name": "Southern Africa",
    "db": [
      {
        "id": "BW",
        "un": "BW",
        "name": "Botswana",
        "db": [
          {
            "id": "BW2",
            "name": "Kalahari"
          },
          {
            "id": "BW3",
            "name": "Okavango and Chobe"
          },
          {
            "id": "BW1",
            "name": "Southeast"
          }
        ],
        "total": 3
      },
      {
        "id": "SZ",
        "un": "SZ",
        "name": "Eswatini"
      },
      {
        "id": "LS",
        "un": "LS",
        "name": "Lesotho"
      },
      {
        "id": "NA",
        "un": "NA",
        "name": "Namibia",
        "db": [
          {
            "id": "NA-CA",
            "name": "Caprivi"
          },
          {
            "id": "NA:C",
            "name": "Central"
          },
          {
            "id": "NA:N",
            "name": "North"
          },
          {
            "id": "NA:S",
            "name": "South"
          }
        ],
        "total": 4
      },
      {
        "id": "ZA",
        "un": "ZA",
        "name": "South Africa",
        "db": [
          {
            "id": "ZA-EC",
            "name": "Eastern Cape"
          },
          {
            "id": "ZA-FS",
            "name": "Free State"
          },
          {
            "id": "ZA-GP",
            "name": "Gauteng"
          },
          {
            "id": "ZA-KZN",
            "name": "KwaZulu-Natal"
          },
          {
            "id": "ZA-LP",
            "name": "Limpopo"
          },
          {
            "id": "ZA-MP",
            "name": "Mpumalanga"
          },
          {
            "id": "ZA-NW",
            "name": "North West"
          },
          {
            "id": "ZA-NC",
            "name": "Northern Cape"
          },
          {
            "id": "ZA-WC",
            "name": "Western Cape"
          }
        ],
        "total": 9
      },
      {
        "id": "ZM",
        "un": "ZM",
        "name": "Zambia",
        "db": [
          {
            "id": "ZM:C",
            "name": "Central"
          },
          {
            "id": "ZM-08",
            "name": "Copperbelt Province"
          },
          {
            "id": "ZM-03",
            "name": "Eastern Province"
          },
          {
            "id": "ZM:N",
            "name": "North"
          },
          {
            "id": "ZM:Z",
            "name": "Zambezi Basin"
          }
        ],
        "total": 5
      }
    ],
    "total": 23
  },
  {
    "id": "ASN",
    "name": "Northern Asia",
    "db": [
      {
        "id": "RU",
        "un": "RU",
        "name": "Russian Federation",
        "db": [
          {
            "id": "RU-ALT",
            "name": "Altai Krai"
          },
          {
            "id": "RU-AL",
            "name": "Altai Republic"
          },
          {
            "id": "RU-AMU",
            "name": "Amur Oblast"
          },
          {
            "id": "RU-BU",
            "name": "Buryatia"
          },
          {
            "id": "RU-CHE",
            "name": "Chelyabinsk Oblast"
          },
          {
            "id": "RU-CHU",
            "name": "Chukotka Autonomous Okrug"
          },
          {
            "id": "RU-IRK",
            "name": "Irkutsk Oblast"
          },
          {
            "id": "RU-YEV",
            "name": "Jewish Autonomous Oblast"
          },
          {
            "id": "RU-KAM",
            "name": "Kamchatka Krai"
          },
          {
            "id": "RU-KEM",
            "name": "Kemerovo Oblast–Kuzbass"
          },
          {
            "id": "RU-KHA",
            "name": "Khabarovsk Krai"
          },
          {
            "id": "RU-KHM",
            "name": "Khanty-Mansiysk Autonomous Okrug – Ugra"
          },
          {
            "id": "RU-KYA",
            "name": "Krasnoyarsk Krai"
          },
          {
            "id": "RU-KGN",
            "name": "Kurgan Oblast"
          },
          {
            "id": "RU-MAG",
            "name": "Magadan Oblast"
          },
          {
            "id": "RU-NVS",
            "name": "Novosibirsk Oblast"
          },
          {
            "id": "RU-OMS",
            "name": "Omsk Oblast"
          },
          {
            "id": "RU-PRI",
            "name": "Primorsky Krai"
          },
          {
            "id": "RU-KK",
            "name": "Republic of Khakassia"
          },
          {
            "id": "RU-SA",
            "name": "Sakha Republic"
          },
          {
            "id": "RU-SAK",
            "name": "Sakhalin Oblast"
          },
          {
            "id": "RU-SVE",
            "name": "Sverdlovsk Oblast"
          },
          {
            "id": "RU-TOM",
            "name": "Tomsk Oblast"
          },
          {
            "id": "RU-TY",
            "name": "Tuva Republic"
          },
          {
            "id": "RU-TYU",
            "name": "Tyumen Oblast"
          },
          {
            "id": "RU-YAN",
            "name": "Yamalo-Nenets Autonomous Okrug"
          },
          {
            "id": "RU-ZAB",
            "name": "Zabaykalsky Krai"
          }
        ],
        "total": 27
      }
    ],
    "total": 27
  },
  {
    "id": "ASW",
    "name": "Western Asia",
    "db": [
      {
        "id": "XA",
        "un": "GE",
        "name": "Abkhazia",
        "db": [
          {
            "id": "XA",
            "name": "Abkhazia"
          }
        ],
        "total": 1
      },
      {
        "id": "XD",
        "un": "GB",
        "name": "Akrotiri and Dhekelia (Sovereign Base Areas)"
      },
      {
        "id": "AM",
        "un": "AM",
        "name": "Armenia"
      },
      {
        "id": "AZ",
        "un": "AZ",
        "name": "Azerbaijan",
        "db": [
          {
            "id": "AZ:1",
            "name": "Azerbaijan"
          },
          {
            "id": "AZ:K",
            "name": "Karabakh"
          },
          {
            "id": "AZ-NX",
            "name": "Nakhchivan"
          }
        ],
        "total": 3
      },
      {
        "id": "BH",
        "un": "BH",
        "name": "Bahrain"
      },
      {
        "id": "CY",
        "un": "CY",
        "name": "Cyprus"
      },
      {
        "id": "GE",
        "un": "GE",
        "name": "Georgia",
        "db": [
          {
            "id": "GE-AJ",
            "name": "Adjara"
          },
          {
            "id": "GE1",
            "name": "Georgia"
          }
        ],
        "total": 2
      },
      {
        "id": "IR",
        "un": "IR",
        "name": "Iran",
        "db": [
          {
            "id": "IR-K",
            "name": "Caspian Region"
          },
          {
            "id": "IR-C",
            "name": "Central Iran"
          },
          {
            "id": "IR-AZ",
            "name": "Iranian Azerbaijan"
          },
          {
            "id": "IR-KUR",
            "name": "Iranian Kurdistan"
          },
          {
            "id": "IR-KH",
            "name": "Khorasan"
          },
          {
            "id": "IR-PG",
            "name": "Persian Gulf Region"
          },
          {
            "id": "IR-11",
            "name": "Sistan and Baluchestan Province"
          },
          {
            "id": "IR-W",
            "name": "Western Iran"
          }
        ],
        "total": 8
      },
      {
        "id": "IQ",
        "un": "IQ",
        "name": "Iraq",
        "db": [
          {
            "id": "IQ-N",
            "name": "Al-Jazira"
          },
          {
            "id": "IQ-B",
            "name": "Baghdad Belts"
          },
          {
            "id": "IQ-D",
            "name": "Iraqi Desert"
          },
          {
            "id": "IQ-K",
            "name": "Iraqi Kurdistan"
          },
          {
            "id": "IQ-S",
            "name": "Lower Mesopotamia"
          }
        ],
        "total": 5
      },
      {
        "id": "IL",
        "un": "IL",
        "name": "Israel"
      },
      {
        "id": "JO",
        "un": "JO",
        "name": "Jordan"
      },
      {
        "id": "KW",
        "un": "KW",
        "name": "Kuwait"
      },
      {
        "id": "LB",
        "un": "LB",
        "name": "Lebanon"
      },
      {
        "id": "XC",
        "un": "CY",
        "name": "Northern Cyprus"
      },
      {
        "id": "OM",
        "un": "OM",
        "name": "Oman",
        "db": [
          {
            "id": "OM2",
            "name": "Central Oman"
          },
          {
            "id": "OM-ZU",
            "name": "Dhofar"
          },
          {
            "id": "OM-MU",
            "name": "Musandam"
          },
          {
            "id": "OM1",
            "name": "Northern Oman"
          }
        ],
        "total": 4
      },
      {
        "id": "PS",
        "un": "ZZ",
        "name": "Palestine"
      },
      {
        "id": "QA",
        "un": "QA",
        "name": "Qatar"
      },
      {
        "id": "SA",
        "un": "SA",
        "name": "Saudi Arabia",
        "db": [
          {
            "id": "SA-S",
            "name": "Asir"
          },
          {
            "id": "SA-B",
            "name": "Badiah"
          },
          {
            "id": "SA-04",
            "name": "Eastern Province"
          },
          {
            "id": "SA-H",
            "name": "Hejaz"
          },
          {
            "id": "SA-N",
            "name": "Najd"
          }
        ],
        "total": 5
      },
      {
        "id": "XO",
        "un": "GE",
        "name": "South Ossetia"
      },
      {
        "id": "SY",
        "un": "SY",
        "name": "Syria"
      },
      {
        "id": "TR",
        "un": "TR",
        "name": "Türkiye",
        "db": [
          {
            "id": "TR-AEG",
            "name": "Aegean"
          },
          {
            "id": "TR-BLC",
            "name": "Black Sea"
          },
          {
            "id": "TR-CAN",
            "name": "Central Anatolia"
          },
          {
            "id": "TR-EAN",
            "name": "Eastern Anatolia"
          },
          {
            "id": "TR-34",
            "name": "Istanbul"
          },
          {
            "id": "TR-MAR",
            "name": "Marmara"
          },
          {
            "id": "TR-MED",
            "name": "Mediterranean"
          },
          {
            "id": "TR-SEA",
            "name": "Southeastern Anatolia"
          }
        ],
        "total": 8
      },
      {
        "id": "AE",
        "un": "AE",
        "name": "United Arab Emirates",
        "db": [
          {
            "id": "AE-AZ",
            "name": "Abu Dhabi Emirate"
          },
          {
            "id": "AE-AJ",
            "name": "Ajman Emirate"
          },
          {
            "id": "AE-DU",
            "name": "Dubai"
          },
          {
            "id": "AE-FU",
            "name": "Fujairah Emirate"
          },
          {
            "id": "AE-RK",
            "name": "Ras al-Khaimah"
          },
          {
            "id": "AE-SH",
            "name": "Sharjah Emirate"
          },
          {
            "id": "AE-UQ",
            "name": "Umm al-Quwain"
          }
        ],
        "total": 7
      },
      {
        "id": "YE",
        "un": "YE",
        "name": "Yemen",
        "db": [
          {
            "id": "YE:N",
            "name": "North"
          },
          {
            "id": "YE:S",
            "name": "South"
          }
        ],
        "total": 2
      }
    ],
    "total": 58
  },
  {
    "id": "ASC",
    "name": "Central Asia",
    "db": [
      {
        "id": "KZ",
        "un": "KZ",
        "name": "Kazakhstan",
        "db": [
          {
            "id": "KZ-AA",
            "name": "Almaty Region"
          },
          {
            "id": "KZ-63",
            "name": "Altai"
          },
          {
            "id": "KZ-K",
            "name": "Caspian Region"
          },
          {
            "id": "KZ-C",
            "name": "Central Kazakhstan"
          },
          {
            "id": "KZ-N",
            "name": "North Kazakhstan"
          },
          {
            "id": "KZ-S",
            "name": "South Kazakhstan"
          }
        ],
        "total": 6
      },
      {
        "id": "KG",
        "un": "KG",
        "name": "Kyrgyzstan",
        "db": [
          {
            "id": "KG-1",
            "name": "Bishkek and the North"
          },
          {
            "id": "KG-2",
            "name": "Ferghana Valley"
          },
          {
            "id": "KG-Y",
            "name": "Issyk-Kul Region"
          },
          {
            "id": "KG-N",
            "name": "Naryn Region"
          }
        ],
        "total": 4
      },
      {
        "id": "TJ",
        "un": "TJ",
        "name": "Tajikistan",
        "db": [
          {
            "id": "TJ-GB",
            "name": "Gorno-Badakhshan"
          },
          {
            "id": "TJ-1",
            "name": "Karategin"
          },
          {
            "id": "TJ-KT",
            "name": "Khatlon"
          },
          {
            "id": "TJ-SU",
            "name": "Sughd Region"
          }
        ],
        "total": 4
      },
      {
        "id": "TM",
        "un": "TM",
        "name": "Turkmenistan",
        "db": [
          {
            "id": "TM-B",
            "name": "Balkan Region"
          },
          {
            "id": "TM1",
            "name": "North"
          },
          {
            "id": "TM2",
            "name": "South"
          }
        ],
        "total": 3
      },
      {
        "id": "UZ",
        "un": "UZ",
        "name": "Uzbekistan",
        "db": [
          {
            "id": "UZ-F",
            "name": "Ferghana Valley"
          },
          {
            "id": "UZ-QR",
            "name": "Karakalpakstan"
          },
          {
            "id": "UZ-N",
            "name": "Northern Uzbekistan"
          },
          {
            "id": "UZ-B",
            "name": "Samarkand, Bukhara and Khiva"
          },
          {
            "id": "UZ-S",
            "name": "Southern Uzbekistan"
          },
          {
            "id": "UZ-T",
            "name": "Tashkent Region"
          }
        ],
        "total": 6
      }
    ],
    "total": 23
  },
  {
    "id": "ASS",
    "name": "Southern Asia",
    "db": [
      {
        "id": "AF",
        "un": "AF",
        "name": "Afghanistan",
        "db": [
          {
            "id": "AF-E",
            "name": "East"
          },
          {
            "id": "AF-NE",
            "name": "Northeast"
          },
          {
            "id": "AF-NW",
            "name": "Northwest"
          },
          {
            "id": "AF-S",
            "name": "South"
          },
          {
            "id": "AF-W",
            "name": "West"
          }
        ],
        "total": 5
      },
      {
        "id": "BD",
        "un": "BD",
        "name": "Bangladesh",
        "db": [
          {
            "id": "BD-1",
            "name": "Central Bengal Region"
          },
          {
            "id": "BD-4",
            "name": "Eastern Bengal"
          },
          {
            "id": "BD-2",
            "name": "Northern Bengal"
          },
          {
            "id": "BD-3",
            "name": "Southern Bengal"
          }
        ],
        "total": 4
      },
      {
        "id": "BT",
        "un": "BT",
        "name": "Bhutan"
      },
      {
        "id": "IN",
        "un": "IN",
        "name": "India",
        "db": [
          {
            "id": "IN-AP",
            "name": "Andhra Pradesh"
          },
          {
            "id": "IN-AR",
            "name": "Arunachal Pradesh"
          },
          {
            "id": "IN-AS",
            "name": "Assam"
          },
          {
            "id": "IN-BR",
            "name": "Bihar"
          },
          {
            "id": "IN-CH",
            "name": "Chandigarh"
          },
          {
            "id": "IN-CT",
            "name": "Chhattisgarh"
          },
          {
            "id": "IN-DL",
            "name": "Delhi"
          },
          {
            "id": "IN-GA",
            "name": "Goa"
          },
          {
            "id": "IN-GJ",
            "name": "Gujarat"
          },
          {
            "id": "IN-HR",
            "name": "Haryana"
          },
          {
            "id": "IN-HP",
            "name": "Himachal Pradesh"
          },
          {
            "id": "IN-JK",
            "name": "Jammu and Kashmir"
          },
          {
            "id": "IN-JH",
            "name": "Jharkhand"
          },
          {
            "id": "IN-KA",
            "name": "Karnataka"
          },
          {
            "id": "IN-KL",
            "name": "Kerala"
          },
          {
            "id": "IN-LA",
            "name": "Ladakh"
          },
          {
            "id": "IN-MP",
            "name": "Madhya Pradesh"
          },
          {
            "id": "IN-MH",
            "name": "Maharashtra"
          },
          {
            "id": "IN-MN",
            "name": "Manipur"
          },
          {
            "id": "IN-ML",
            "name": "Meghalaya"
          },
          {
            "id": "IN-MZ",
            "name": "Mizoram"
          },
          {
            "id": "IN-NL",
            "name": "Nagaland"
          },
          {
            "id": "IN-OR",
            "name": "Odisha"
          },
          {
            "id": "IN-PY",
            "name": "Puducherry"
          },
          {
            "id": "IN-PB",
            "name": "Punjab"
          },
          {
            "id": "IN-RJ",
            "name": "Rajasthan"
          },
          {
            "id": "IN-SK",
            "name": "Sikkim"
          },
          {
            "id": "IN-TN",
            "name": "Tamil Nadu"
          },
          {
            "id": "IN-TG",
            "name": "Telangana"
          },
          {
            "id": "IN-TR",
            "name": "Tripura"
          },
          {
            "id": "IN-UP",
            "name": "Uttar Pradesh"
          },
          {
            "id": "IN-UT",
            "name": "Uttarakhand"
          },
          {
            "id": "IN-WB",
            "name": "West Bengal"
          }
        ],
        "total": 33
      },
      {
        "id": "MV",
        "un": "MV",
        "name": "Maldives"
      },
      {
        "id": "NP",
        "un": "NP",
        "name": "Nepal"
      },
      {
        "id": "PK",
        "un": "PK",
        "name": "Pakistan",
        "db": [
          {
            "id": "PK-JK",
            "name": "Azad Kashmir"
          },
          {
            "id": "PK-BA",
            "name": "Balochistan"
          },
          {
            "id": "PK-GB",
            "name": "Gilgit-Baltistan"
          },
          {
            "id": "PK-IS",
            "name": "Islamabad Capital Territory"
          },
          {
            "id": "PK-KP",
            "name": "Khyber Pakhtunkhwa"
          },
          {
            "id": "PK-PB",
            "name": "Punjab"
          },
          {
            "id": "PK-SD",
            "name": "Sindh"
          }
        ],
        "total": 7
      },
      {
        "id": "LK",
        "un": "LK",
        "name": "Sri Lanka",
        "db": [
          {
            "id": "LK-5",
            "name": "Eastern Province"
          },
          {
            "id": "LK-4",
            "name": "Northern Province"
          },
          {
            "id": "LK1",
            "name": "West and South"
          }
        ],
        "total": 3
      }
    ],
    "total": 55
  },
  {
    "id": "ASE",
    "name": "Eastern Asia",
    "db": [
      {
        "id": "CN",
        "un": "CN",
        "name": "China",
        "db": [
          {
            "id": "CN-AH",
            "name": "Anhui"
          },
          {
            "id": "CN-BJ",
            "name": "Beijing"
          },
          {
            "id": "CN-CQ",
            "name": "Chongqing"
          },
          {
            "id": "CN-FJ",
            "name": "Fujian"
          },
          {
            "id": "CN-GS",
            "name": "Gansu"
          },
          {
            "id": "CN-GD",
            "name": "Guangdong Province"
          },
          {
            "id": "CN-GX",
            "name": "Guangxi"
          },
          {
            "id": "CN-GZ",
            "name": "Guizhou"
          },
          {
            "id": "CN-HI",
            "name": "Hainan Province"
          },
          {
            "id": "CN-HE",
            "name": "Hebei"
          },
          {
            "id": "CN-HL",
            "name": "Heilongjiang"
          },
          {
            "id": "CN-HA",
            "name": "Henan"
          },
          {
            "id": "CN-HB",
            "name": "Hubei"
          },
          {
            "id": "CN-HN",
            "name": "Hunan"
          },
          {
            "id": "CN-NM",
            "name": "Inner Mongolia"
          },
          {
            "id": "CN-JS",
            "name": "Jiangsu"
          },
          {
            "id": "CN-JX",
            "name": "Jiangxi"
          },
          {
            "id": "CN-JL",
            "name": "Jilin"
          },
          {
            "id": "CN-LN",
            "name": "Liaoning"
          },
          {
            "id": "CN-NX",
            "name": "Ningxia"
          },
          {
            "id": "CN-QH",
            "name": "Qinghai"
          },
          {
            "id": "CN-SN",
            "name": "Shaanxi"
          },
          {
            "id": "CN-SD",
            "name": "Shandong"
          },
          {
            "id": "CN-SH",
            "name": "Shanghai"
          },
          {
            "id": "CN-SX",
            "name": "Shanxi"
          },
          {
            "id": "CN-SC",
            "name": "Sichuan"
          },
          {
            "id": "CN-TJ",
            "name": "Tianjin"
          },
          {
            "id": "CN-XZ",
            "name": "Tibet"
          },
          {
            "id": "CN-XJ",
            "name": "Xinjiang"
          },
          {
            "id": "CN-YN",
            "name": "Yunnan"
          },
          {
            "id": "CN-ZJ",
            "name": "Zhejiang"
          }
        ],
        "total": 31
      },
      {
        "id": "HK",
        "un": "CN",
        "name": "Hong Kong"
      },
      {
        "id": "JP",
        "un": "JP",
        "name": "Japan",
        "db": [
          {
            "id": "JP:D",
            "name": "Chūbu"
          },
          {
            "id": "JP:F",
            "name": "Chūgoku"
          },
          {
            "id": "JP-01",
            "name": "Hokkaido"
          },
          {
            "id": "JP:E",
            "name": "Kansai"
          },
          {
            "id": "JP:C",
            "name": "Kantō"
          },
          {
            "id": "JP:H",
            "name": "Kyushu"
          },
          {
            "id": "JP-47",
            "name": "Okinawa"
          },
          {
            "id": "JP:G",
            "name": "Shikoku"
          },
          {
            "id": "JP:B",
            "name": "Tōhoku"
          }
        ],
        "total": 9
      },
      {
        "id": "KP",
        "un": "KP",
        "name": "Korea, North",
        "db": [
          {
            "id": "KP:HK",
            "name": "Hamgyong"
          },
          {
            "id": "KP:HH",
            "name": "Hwanghae"
          },
          {
            "id": "KP:GW",
            "name": "Kangwon"
          },
          {
            "id": "KP:PA",
            "name": "Pyongan"
          }
        ],
        "total": 4
      },
      {
        "id": "KR",
        "un": "KR",
        "name": "Korea, South",
        "db": [
          {
            "id": "KR:CC",
            "name": "Chungcheong"
          },
          {
            "id": "KR-42",
            "name": "Gangwon"
          },
          {
            "id": "KR:GG",
            "name": "Gyeonggi"
          },
          {
            "id": "KR:GS",
            "name": "Gyeongsang"
          },
          {
            "id": "KR-49",
            "name": "Jeju"
          },
          {
            "id": "KR:JN",
            "name": "Jeolla"
          }
        ],
        "total": 6
      },
      {
        "id": "MO",
        "un": "CN",
        "name": "Macao"
      },
      {
        "id": "MN",
        "un": "MN",
        "name": "Mongolia",
        "db": [
          {
            "id": "MN-C",
            "name": "Central Mongolia"
          },
          {
            "id": "MN-E",
            "name": "Eastern Mongolia"
          },
          {
            "id": "MN-G",
            "name": "Gobi"
          },
          {
            "id": "MN-N",
            "name": "Northern Mongolia"
          },
          {
            "id": "MN-W",
            "name": "Western Mongolia"
          }
        ],
        "total": 5
      },
      {
        "id": "TW",
        "un": "CN",
        "name": "Taiwan"
      }
    ],
    "total": 58
  },
  {
    "id": "SEA",
    "name": "Southeast Asia",
    "db": [
      {
        "id": "BN",
        "un": "BN",
        "name": "Brunei Darussalam",
        "db": [
          {
            "id": "BN",
            "name": "Brunei-Muara, Belait, and Tutong"
          },
          {
            "id": "BN-TE",
            "name": "Temburong"
          }
        ],
        "total": 2
      },
      {
        "id": "KH",
        "un": "KH",
        "name": "Cambodia"
      },
      {
        "id": "ID",
        "un": "ID",
        "name": "Indonesia",
        "db": [
          {
            "id": "ID-BA",
            "name": "Bali"
          },
          {
            "id": "ID-BB",
            "name": "Bangka-Belitung Islands"
          },
          {
            "id": "ID-NT",
            "name": "East Nusa Tenggara"
          },
          {
            "id": "ID-JW",
            "name": "Java"
          },
          {
            "id": "ID-KA",
            "name": "Kalimantan (Indonesian Borneo)"
          },
          {
            "id": "ID-MA",
            "name": "Maluku"
          },
          {
            "id": "ID-MU",
            "name": "North Maluku"
          },
          {
            "id": "ID-PP",
            "name": "Papua (Western New Guinea)"
          },
          {
            "id": "ID-KR",
            "name": "Riau Islands"
          },
          {
            "id": "ID-PD",
            "name": "Southwest Papua"
          },
          {
            "id": "ID-SL",
            "name": "Sulawesi"
          },
          {
            "id": "ID-SM",
            "name": "Sumatra"
          },
          {
            "id": "ID-NB",
            "name": "West Nusa Tenggara"
          }
        ],
        "total": 13
      },
      {
        "id": "LA",
        "un": "LA",
        "name": "Laos",
        "db": [
          {
            "id": "LA:C",
            "name": "Central"
          },
          {
            "id": "LA:N",
            "name": "North"
          },
          {
            "id": "LA:S",
            "name": "South"
          }
        ],
        "total": 3
      },
      {
        "id": "MY",
        "un": "MY",
        "name": "Malaysia",
        "db": [
          {
            "id": "MY:2",
            "name": "East Coast"
          },
          {
            "id": "MY-01",
            "name": "Johor"
          },
          {
            "id": "MY:SA",
            "name": "Sabah"
          },
          {
            "id": "MY-13",
            "name": "Sarawak"
          },
          {
            "id": "MY:1",
            "name": "West Coast"
          }
        ],
        "total": 5
      },
      {
        "id": "MM",
        "un": "MM",
        "name": "Myanmar",
        "db": [
          {
            "id": "MM:C",
            "name": "Central"
          },
          {
            "id": "MM:E",
            "name": "East"
          },
          {
            "id": "MM:N",
            "name": "North"
          },
          {
            "id": "MM:S",
            "name": "South"
          },
          {
            "id": "MM:SE",
            "name": "Southeast"
          },
          {
            "id": "MM:W",
            "name": "West"
          }
        ],
        "total": 6
      },
      {
        "id": "PH",
        "un": "PH",
        "name": "Philippines",
        "db": [
          {
            "id": "PH-ME",
            "name": "Eastern Mindanao"
          },
          {
            "id": "PH-L",
            "name": "Luzon"
          },
          {
            "id": "PH-00",
            "name": "Metro Manila"
          },
          {
            "id": "PH-PLW",
            "name": "Palawan"
          },
          {
            "id": "PH-V",
            "name": "Visayas"
          },
          {
            "id": "PH-MW",
            "name": "Western Mindanao and Sulu"
          }
        ],
        "total": 6
      },
      {
        "id": "SG",
        "un": "SG",
        "name": "Singapore"
      },
      {
        "id": "TH",
        "un": "TH",
        "name": "Thailand",
        "db": [
          {
            "id": "TH-C",
            "name": "Central"
          },
          {
            "id": "TH-E",
            "name": "Eastern"
          },
          {
            "id": "TH-NE",
            "name": "Isaan"
          },
          {
            "id": "TH-N",
            "name": "Northern"
          },
          {
            "id": "TH-S",
            "name": "Southern"
          },
          {
            "id": "TH-W",
            "name": "Western"
          }
        ],
        "total": 6
      },
      {
        "id": "TL",
        "un": "TL",
        "name": "Timor-Leste",
        "db": [
          {
            "id": "TL-N",
            "name": "North Coast"
          },
          {
            "id": "TL-OE",
            "name": "Oecussi"
          },
          {
            "id": "TL-S",
            "name": "South Coast"
          }
        ],
        "total": 3
      },
      {
        "id": "VN",
        "un": "VN",
        "name": "Viet Nam",
        "db": [
          {
            "id": "VN:CH",
            "name": "Central Highlands"
          },
          {
            "id": "VN:MD",
            "name": "Mekong River Delta"
          },
          {
            "id": "VN:NCC",
            "name": "North Central Coast"
          },
          {
            "id": "VN:NE",
            "name": "Northeast"
          },
          {
            "id": "VN:NW",
            "name": "Northwest"
          },
          {
            "id": "VN:RRD",
            "name": "Red River Delta"
          },
          {
            "id": "VN:SCC",
            "name": "South Central Coast"
          },
          {
            "id": "VN:SE",
            "name": "Southeast"
          }
        ],
        "total": 8
      }
    ],
    "total": 54
  },
  {
    "id": "IND",
    "name": "Indian Ocean",
    "db": [
      {
        "id": "IO",
        "un": "GB",
        "name": "British Indian Ocean Territory"
      },
      {
        "id": "CX",
        "un": "AU",
        "name": "Christmas Island"
      },
      {
        "id": "CC",
        "un": "AU",
        "name": "Cocos (Keeling) Islands"
      },
      {
        "id": "TF",
        "un": "FR",
        "name": "French Southern and Antarctic Lands",
        "db": [
          {
            "id": "TF",
            "name": "French Southern and Antarctic Lands"
          }
        ],
        "total": 1
      },
      {
        "id": "HM",
        "un": "AU",
        "name": "Heard Island and McDonald Islands",
        "db": [
          {
            "id": "HM",
            "name": "Heard Island and McDonald Islands"
          }
        ],
        "total": 1
      },
      {
        "id": "IN",
        "un": "IN",
        "name": "India",
        "db": [
          {
            "id": "IN-AN",
            "name": "Andaman and Nicobar Islands"
          },
          {
            "id": "IN-LD",
            "name": "Lakshadweep"
          }
        ],
        "total": 2
      },
      {
        "id": "MU",
        "un": "MU",
        "name": "Mauritius",
        "db": [
          {
            "id": "MU:0",
            "name": "Mauritius"
          },
          {
            "id": "MU-RO",
            "name": "Rodrigues"
          }
        ],
        "total": 2
      },
      {
        "id": "YT",
        "un": "FR",
        "name": "Mayotte"
      },
      {
        "id": "RE",
        "un": "FR",
        "name": "Réunion"
      },
      {
        "id": "SC",
        "un": "SC",
        "name": "Seychelles",
        "db": [
          {
            "id": "SC:0",
            "name": "Inner Islands"
          },
          {
            "id": "SC:2",
            "name": "Outer Islands - Zil Elwannyen Sesel"
          }
        ],
        "total": 2
      },
      {
        "id": "YE",
        "un": "YE",
        "name": "Yemen",
        "db": [
          {
            "id": "YE-SU",
            "name": "Socotra"
          }
        ],
        "total": 1
      }
    ],
    "total": 14
  },
  {
    "id": "ANZ",
    "name": "Australia and New Zealand",
    "db": [
      {
        "id": "AU",
        "un": "AU",
        "name": "Australia",
        "db": [
          {
            "id": "AU-ACT",
            "name": "Australian Capital Territory"
          },
          {
            "id": "AU-LDH",
            "name": "Lord Howe Island"
          },
          {
            "id": "AU-NSW",
            "name": "New South Wales"
          },
          {
            "id": "AU-NT",
            "name": "Northern Territory"
          },
          {
            "id": "AU-QLD",
            "name": "Queensland"
          },
          {
            "id": "AU-SA",
            "name": "South Australia"
          },
          {
            "id": "AU-TAS",
            "name": "Tasmania"
          },
          {
            "id": "AU-VIC",
            "name": "Victoria"
          },
          {
            "id": "AU-WA",
            "name": "Western Australia"
          }
        ],
        "total": 9
      },
      {
        "id": "NZ",
        "un": "NZ",
        "name": "New Zealand",
        "db": [
          {
            "id": "NZ-CIT",
            "name": "Chatham Islands"
          },
          {
            "id": "NZ:NN",
            "name": "North Island North"
          },
          {
            "id": "NZ:NS",
            "name": "North Island South"
          },
          {
            "id": "NZ:SE",
            "name": "South Island East"
          },
          {
            "id": "NZ:SW",
            "name": "South Island West"
          },
          {
            "id": "NZ-STW",
            "name": "Stewart / Rakiura"
          }
        ],
        "total": 6
      },
      {
        "id": "NF",
        "un": "AU",
        "name": "Norfolk Island"
      }
    ],
    "total": 16
  },
  {
    "id": "MEL",
    "name": "Melanesia",
    "db": [
      {
        "id": "FJ",
        "un": "FJ",
        "name": "Fiji",
        "db": [
          {
            "id": "FJ-E",
            "name": "Kadavu, Lau, Lomaiviti"
          },
          {
            "id": "FJ-R",
            "name": "Rotuma"
          },
          {
            "id": "FJ-N",
            "name": "Vanua Levu"
          },
          {
            "id": "FJ:VL",
            "name": "Viti Levu"
          }
        ],
        "total": 4
      },
      {
        "id": "NC",
        "un": "FR",
        "name": "New Caledonia",
        "db": [
          {
            "id": "NC:LIP",
            "name": "Loyalty Islands Province"
          },
          {
            "id": "NC:NP",
            "name": "North Province"
          },
          {
            "id": "NC:SP",
            "name": "South Province"
          }
        ],
        "total": 3
      },
      {
        "id": "PG",
        "un": "PG",
        "name": "Papua New Guinea",
        "db": [
          {
            "id": "PG-NSB",
            "name": "Bougainville"
          },
          {
            "id": "PG-C",
            "name": "Central"
          },
          {
            "id": "PG-H",
            "name": "Highlands"
          },
          {
            "id": "PG-MBA",
            "name": "Milne Bay"
          },
          {
            "id": "PG-M",
            "name": "Momase"
          },
          {
            "id": "PG-NB",
            "name": "New Britain"
          },
          {
            "id": "PG-IM",
            "name": "New Ireland and Manus"
          },
          {
            "id": "PG-S",
            "name": "South"
          }
        ],
        "total": 8
      },
      {
        "id": "SB",
        "un": "SB",
        "name": "Solomon Islands"
      },
      {
        "id": "VU",
        "un": "VU",
        "name": "Vanuatu"
      }
    ],
    "total": 17
  },
  {
    "id": "MIC",
    "name": "Micronesia",
    "db": [
      {
        "id": "GU",
        "un": "US",
        "name": "Guam",
        "db": [
          {
            "id": "GU",
            "name": "Guam"
          }
        ],
        "total": 1
      },
      {
        "id": "JP",
        "un": "JP",
        "name": "Japan",
        "db": [
          {
            "id": "JP-13:1",
            "name": "Ogasawara (Bonin) Islands"
          }
        ],
        "total": 1
      },
      {
        "id": "KI",
        "un": "KI",
        "name": "Kiribati",
        "db": [
          {
            "id": "KI-G",
            "name": "Gilbert Islands"
          },
          {
            "id": "KI-L",
            "name": "Line Islands"
          },
          {
            "id": "KI-P",
            "name": "Phoenix Islands"
          }
        ],
        "total": 3
      },
      {
        "id": "MH",
        "un": "MH",
        "name": "Marshall Islands"
      },
      {
        "id": "FM",
        "un": "FM",
        "name": "Micronesia",
        "db": [
          {
            "id": "FM-TRK",
            "name": "Chuuk"
          },
          {
            "id": "FM-KSA",
            "name": "Kosrae"
          },
          {
            "id": "FM-PNI",
            "name": "Pohnpei"
          },
          {
            "id": "FM-YAP",
            "name": "Yap"
          }
        ],
        "total": 4
      },
      {
        "id": "NR",
        "un": "NR",
        "name": "Nauru"
      },
      {
        "id": "MP",
        "un": "US",
        "name": "Northern Mariana Islands",
        "db": [
          {
            "id": "MP",
            "name": "Northern Mariana Islands"
          }
        ],
        "total": 1
      },
      {
        "id": "PW",
        "un": "PW",
        "name": "Palau"
      }
    ],
    "total": 13
  },
  {
    "id": "POL",
    "name": "Polynesia",
    "db": [
      {
        "id": "AS",
        "un": "US",
        "name": "American Samoa",
        "db": [
          {
            "id": "AS",
            "name": "American Samoa"
          }
        ],
        "total": 1
      },
      {
        "id": "CL",
        "un": "CL",
        "name": "Chile",
        "db": [
          {
            "id": "CL-VS:1",
            "name": "Easter Island"
          }
        ],
        "total": 1
      },
      {
        "id": "CK",
        "un": "NZ",
        "name": "Cook Islands"
      },
      {
        "id": "PF",
        "un": "FR",
        "name": "French Polynesia",
        "db": [
          {
            "id": "PF:A",
            "name": "Austral Islands"
          },
          {
            "id": "PF:G",
            "name": "Gambiers"
          },
          {
            "id": "PF:M",
            "name": "Marquesas"
          },
          {
            "id": "PF:S",
            "name": "Society Islands"
          },
          {
            "id": "PF:T",
            "name": "Tuamotus"
          }
        ],
        "total": 5
      },
      {
        "id": "NU",
        "un": "NZ",
        "name": "Niue"
      },
      {
        "id": "PN",
        "un": "GB",
        "name": "Pitcairn"
      },
      {
        "id": "WS",
        "un": "WS",
        "name": "Samoa",
        "db": [
          {
            "id": "WS:S",
            "name": "Savaiʻi"
          },
          {
            "id": "WS:U",
            "name": "Upolu"
          }
        ],
        "total": 2
      },
      {
        "id": "TK",
        "un": "NZ",
        "name": "Tokelau"
      },
      {
        "id": "TO",
        "un": "TO",
        "name": "Tonga",
        "db": [
          {
            "id": "TO-02",
            "name": "Haʻapai"
          },
          {
            "id": "TO:T",
            "name": "Tongatapu group"
          },
          {
            "id": "TO:VN",
            "name": "Vavaʻu and Niua"
          }
        ],
        "total": 3
      },
      {
        "id": "TV",
        "un": "TV",
        "name": "Tuvalu"
      },
      {
        "id": "UM",
        "un": "US",
        "name": "United States Minor Outlying Islands"
      },
      {
        "id": "US",
        "un": "US",
        "name": "United States of America",
        "db": [
          {
            "id": "US-HI",
            "name": "Hawaii"
          }
        ],
        "total": 1
      },
      {
        "id": "WF",
        "un": "FR",
        "name": "Wallis and Futuna",
        "db": [
          {
            "id": "WF:F",
            "name": "Futuna"
          },
          {
            "id": "WF:W",
            "name": "Wallis"
          }
        ],
        "total": 2
      }
    ],
    "total": 21
  },
  {
    "id": "ANT",
    "name": "Antarctica",
    "db": [
      {
        "id": "AQ",
        "un": "ZZ",
        "name": "Antarctica"
      }
    ],
    "total": 1
  }
];
